(function ($) {
    "use strict";

    if (typeof hcpIndicatorsV2 === "undefined") return;

    var cfg = hcpIndicatorsV2;
    var ajax = cfg.ajaxUrl;
    var nonce = cfg.nonce;
    var i18n = cfg.i18n;
    cfg.publishedYear = parseInt(cfg.publishedYear, 10) || 0;
    cfg.currentYear = parseInt(cfg.currentYear, 10) || 0;

    // ── State ─────────────────────────────────────────────────────────────────

    var availableFields = []; // all filterable fields from API

    var state = {
        tabs: [],
        kpis: [],
        activeTab: null,
        chartObjs: {},
        filters: {
            years: [],
            entityTypes: [],
            fieldFilters: {}, // { "fieldId": [value, value, ...] }
        },
        activeFieldIds: [], // ordered list of field IDs added to filters
        pendingFieldFilters: null,
        refreshTimer: null,
        renderGen: 0,
    };

    // ── Helpers ───────────────────────────────────────────────────────────────

    function post(action, data, cb) {
        $.post(ajax, Object.assign({ action: action, nonce: nonce }, data), function (res) {
            if (res && res.success) {
                cb(res.data);
            }
        });
    }

    function debounce(fn, ms) {
        return function () {
            clearTimeout(state.refreshTimer);
            state.refreshTimer = setTimeout(fn, ms);
        };
    }

    var debouncedRefresh = debounce(refreshActiveTab, 300);

    var loadingSpinner =
        '<svg fill="hsl(228, 97%, 42%)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="size-7">' +
        '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
        '<animateTransform id="spinner_XR07" begin="0;spinner_npiH.begin+0.4s" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
        '<animateTransform begin="0;spinner_npiH.begin+0.4s" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
        '<animate begin="0;spinner_npiH.begin+0.4s" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
        "</path>" +
        '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
        '<animateTransform id="spinner_r5ci" begin="spinner_XR07.begin+0.4s" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
        '<animateTransform begin="spinner_XR07.begin+0.4s" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
        '<animate begin="spinner_XR07.begin+0.4s" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
        "</path>" +
        '<path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" transform="translate(12, 12) scale(0)">' +
        '<animateTransform id="spinner_npiH" begin="spinner_XR07.begin+0.8s" attributeName="transform" calcMode="spline" type="translate" dur="1.2s" values="12 12;0 0" keySplines=".52,.6,.25,.99"/>' +
        '<animateTransform begin="spinner_XR07.begin+0.8s" attributeName="transform" calcMode="spline" additive="sum" type="scale" dur="1.2s" values="0;1" keySplines=".52,.6,.25,.99"/>' +
        '<animate begin="spinner_XR07.begin+0.8s" attributeName="opacity" calcMode="spline" dur="1.2s" values="1;0" keySplines=".52,.6,.25,.99"/>' +
        "</path>" +
        "</svg>";

    // ── Boot ──────────────────────────────────────────────────────────────────

    $(function () {
        loadTabsAndKPIs();
        loadFilterableFields();
        bindFilters();
        bindYearDropdown();
    });

    function loadTabsAndKPIs() {
        post("hcp_ind_get_tabs", {}, function (data) {
            state.tabs = data.tabs || [];
            state.kpis = data.kpis || [];

            renderTabsNav();
            loadKPIData();

            if (state.tabs.length > 0) {
                var savedTabId = getTabCookie();
                var tabExists =
                    savedTabId &&
                    state.tabs.find(function (t) {
                        return parseInt(t.id, 10) === savedTabId;
                    });
                activateTab(tabExists ? savedTabId : state.tabs[0].id);
            } else {
                $("#ind-loading").text(i18n.noData);
            }

            var cookieFilters = loadFiltersCookie();
            if (cookieFilters) {
                applyFilters(cookieFilters);
            } else if (data.default_search) {
                applyFilters(data.default_search);
            } else {
                // Default: pre-select the latest available year
                var defaultYear = cfg.publishedYear || cfg.currentYear;
                if (defaultYear) {
                    state.filters.years = [defaultYear];
                    $(".year-pill[data-year='" + defaultYear + "']").addClass("active bg-primary text-white");
                    updateYearDropdownLabel();
                    refreshActiveTab();
                }
            }
        });
    }

    function loadFilterableFields() {
        if (cfg.filterableFields && cfg.filterableFields.length) {
            renderFieldFilters(cfg.filterableFields);
            return;
        }
        post("hcp_ind_get_filterable_fields", {}, function (fields) {
            renderFieldFilters(fields);
        });
    }

    function renderFieldFilters(fields) {
        availableFields = fields || [];

        // Prepend entity type as a virtual filterable field
        if (cfg.entityTypes && cfg.entityTypes.length) {
            var etVirtualField = {
                id: "__et__",
                name: i18n.entityTypeLabel || "Tipologia",
                is_group: false,
                options: cfg.entityTypes.map(function (et) {
                    return { value: et.type_key, label: et.name };
                }),
            };
            availableFields = [etVirtualField].concat(availableFields);
        }

        var $area = $("#field-filters-area");
        $area.empty();

        if (!availableFields.length) return;

        $area.append('<div class="flex flex-wrap gap-2 items-center" id="field-filter-pills-row"></div>');

        syncFieldFilterUI();

        if (state.pendingFieldFilters) {
            var pendingGroupIds = [];
            Object.keys(state.pendingFieldFilters).forEach(function (fid) {
                state.filters.fieldFilters[fid] = (state.pendingFieldFilters[fid] || []).map(String);
                var group = availableFields.find(function (f) {
                    return (
                        f.is_group &&
                        f.sub_fields &&
                        f.sub_fields.some(function (s) {
                            return String(s.id) === fid;
                        })
                    );
                });
                if (group) {
                    var gid = String(group.id);
                    if (pendingGroupIds.indexOf(gid) === -1) {
                        pendingGroupIds.push(gid);
                        state.activeFieldIds.push(gid);
                    }
                } else {
                    var field = availableFields.find(function (f) {
                        return String(f.id) === fid;
                    });
                    if (field && state.activeFieldIds.indexOf(fid) === -1) {
                        state.activeFieldIds.push(fid);
                    }
                }
            });
            state.pendingFieldFilters = null;
            syncFieldFilterUI();
        }
    }

    function syncFieldFilterUI() {
        var $row = $("#field-filter-pills-row");
        if (!$row.length) return;
        $row.empty();

        var plusSvg =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-6">' +
            '<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            "</svg>";

        var closeSvg =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-6 pointer-events-none">' +
            '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            "</svg>";

        state.activeFieldIds.forEach(function (fid) {
            var field = availableFields.find(function (f) {
                return String(f.id) === fid;
            });
            if (!field) return;

            var optionsHtml = "";
            var pillCount = 0;

            if (field.is_group) {
                var totalSelected = 0;
                field.sub_fields.forEach(function (sub, si) {
                    var sid = String(sub.id);
                    var subActive = state.filters.fieldFilters[sid] || [];
                    totalSelected += subActive.length;
                    var allSubSelected = sub.options.length > 0 && subActive.length === sub.options.length;

                    if (si > 0) optionsHtml += '<hr class="border-primary/20 my-1">';

                    optionsHtml +=
                        '<div class="px-2 pt-2 pb-0.5 text-11 font-bold uppercase tracking-wide text-primary/50">' +
                        escHtml(sub.name) +
                        "</div>" +
                        '<label class="flex items-center gap-2 py-1 px-2 cursor-pointer rounded-lg hover:bg-blue-05 transition-colors">' +
                        '<input type="checkbox" class="field-filter-select-all" data-field-id="' +
                        escHtml(sid) +
                        '" data-group-id="' +
                        escHtml(fid) +
                        '"' +
                        (allSubSelected ? " checked" : "") +
                        "> " +
                        '<span class="text-14 text-primary font-bold">' +
                        escHtml(i18n.selectAll || "Selecionar tudo") +
                        "</span>" +
                        "</label>" +
                        '<hr class="border-primary/10 my-0.5">' +
                        sub.options
                            .map(function (opt) {
                                var checked = subActive.indexOf(String(opt.value)) > -1 ? " checked" : "";
                                return (
                                    '<label class="flex items-center gap-2 py-1 px-2 cursor-pointer rounded-lg hover:bg-blue-05 transition-colors">' +
                                    '<input type="checkbox" class="field-filter-opt" data-field-id="' +
                                    escHtml(sid) +
                                    '" data-group-id="' +
                                    escHtml(fid) +
                                    '" data-value="' +
                                    escHtml(String(opt.value)) +
                                    '"' +
                                    checked +
                                    "> " +
                                    '<span class="text-14 text-primary">' +
                                    escHtml(opt.label) +
                                    "</span>" +
                                    "</label>"
                                );
                            })
                            .join("");
                });
                pillCount = totalSelected;
            } else {
                var activeValues = state.filters.fieldFilters[fid] || [];
                var allSelected = field.options.length > 0 && activeValues.length === field.options.length;
                pillCount = activeValues.length;

                optionsHtml =
                    '<label class="flex items-center gap-2 py-2 px-3 cursor-pointer rounded-full hover:bg-blue-06 transition-colors">' +
                    '<input type="checkbox" class="field-filter-select-all" data-field-id="' +
                    escHtml(fid) +
                    '"' +
                    (allSelected ? " checked" : "") +
                    "> " +
                    '<span class="text-14 text-grey-01">' +
                    escHtml(i18n.selectAll || "Selecionar tudo") +
                    "</span>" +
                    "</label>" +
                    '<hr class="border-primary/10 my-1">' +
                    field.options
                        .map(function (opt) {
                            var checked = activeValues.indexOf(String(opt.value)) > -1 ? " checked" : "";
                            return (
                                '<label class="flex items-center gap-2 py-2 px-3 cursor-pointer rounded-full hover:bg-blue-06 transition-colors">' +
                                '<input type="checkbox" class="field-filter-opt" data-field-id="' +
                                escHtml(fid) +
                                '" data-value="' +
                                escHtml(String(opt.value)) +
                                '"' +
                                checked +
                                "> " +
                                '<span class="text-14 text-grey-01">' +
                                escHtml(opt.label) +
                                "</span>" +
                                "</label>"
                            );
                        })
                        .join("");
            }

            var $pill = $(
                '<div class="relative field-filter-pill-wrapper" data-field-id="' +
                    escHtml(fid) +
                    '">' +
                    '<button type="button" class="field-filter-btn cursor-pointer border border-primary rounded-full px-6 py-4 flex items-center gap-3 text-16 text-primary whitespace-nowrap hover:bg-primary/5 transition-colors"' +
                    ' data-field-id="' +
                    escHtml(fid) +
                    '">' +
                    '<span class="field-filter-name">' +
                    escHtml(field.name) +
                    "</span>" +
                    '<span class="bg-blue-05 rounded px-0.5 text-12 font-bold uppercase text-primary leading-4 min-w-5 text-center field-filter-count">' +
                    pillCount +
                    "</span>" +
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-5 shrink-0 pointer-events-none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                    '<span class="field-filter-remove-btn flex items-center justify-center size-6 shrink-0" data-field-id="' +
                    escHtml(fid) +
                    '">' +
                    closeSvg +
                    "</span>" +
                    "</button>" +
                    '<div class="field-filter-dropdown hidden absolute top-full left-0 mt-2 bg-white border border-blue-06 rounded-2xl z-50 min-w-80 overflow-hidden shadow-hcp">' +
                    '<div class="overflow-auto max-h-72 p-4">' +
                    optionsHtml +
                    "</div>" +
                    "</div>" +
                    "</div>"
            );

            $row.append($pill);
        });

        var addableFields = availableFields.filter(function (f) {
            return state.activeFieldIds.indexOf(String(f.id)) === -1;
        });

        var addOptionsHtml = addableFields.length
            ? addableFields
                  .map(function (f) {
                      return (
                          '<button type="button" class="field-filter-add-option w-full text-left px-4 py-2 text-16 text-grey-01 hover:bg-blue-06 rounded-full transition-colors whitespace-nowrap"' +
                          ' data-field-id="' +
                          f.id +
                          '">' +
                          escHtml(f.name) +
                          "</button>"
                      );
                  })
                  .join("")
            : '<p class="px-3 py-2 text-14 text-primary opacity-50">' +
              escHtml(i18n.noMoreFields || "Sem mais campos") +
              "</p>";

        var $addWrapper = $(
            '<div class="relative" id="field-filter-add-wrapper">' +
                '<button type="button" id="field-filter-add-btn" class="cursor-pointer border border-primary text-primary rounded-full p-4 flex items-center justify-center hover:bg-primary/5 transition-colors">' +
                plusSvg +
                "</button>" +
                '<div id="field-filter-add-dropdown" class="hidden absolute top-full left-0 mt-2 bg-white border border-blue-05 rounded-2xl p-4 z-50 shadow-hcp">' +
                addOptionsHtml +
                "</div>" +
                "</div>"
        );

        $row.append($addWrapper);
    }

    function addFieldFilter(fid) {
        fid = String(fid);
        if (state.activeFieldIds.indexOf(fid) > -1) return;
        var field = availableFields.find(function (f) {
            return String(f.id) === fid;
        });
        if (!field) return;

        state.activeFieldIds.push(fid);
        if (field.is_group) {
            field.sub_fields.forEach(function (sub) {
                state.filters.fieldFilters[String(sub.id)] = sub.options.map(function (opt) {
                    return String(opt.value);
                });
            });
        } else {
            state.filters.fieldFilters[fid] = field.options.map(function (opt) {
                return String(opt.value);
            });
        }

        syncFieldFilterUI();
        markFiltersPending();
    }

    function removeFieldFilter(fid) {
        fid = String(fid);
        var idx = state.activeFieldIds.indexOf(fid);
        if (idx > -1) state.activeFieldIds.splice(idx, 1);
        var field = availableFields.find(function (f) {
            return String(f.id) === fid;
        });
        if (field && field.is_group) {
            field.sub_fields.forEach(function (sub) {
                delete state.filters.fieldFilters[String(sub.id)];
            });
        } else {
            delete state.filters.fieldFilters[fid];
        }

        syncFieldFilterUI();
        markFiltersPending();
    }

    function closeAllFieldDropdowns() {
        $(".field-filter-dropdown").addClass("hidden");
        $("#field-filter-add-dropdown").addClass("hidden");
    }

    // ── KPI blocks ────────────────────────────────────────────────────────────

    function loadKPIData() {
        var year = cfg.currentYear;
        var prev_year = year - 1;

        post("hcp_ind_get_kpi_data", { year: year, prev_year: prev_year }, function (kpis) {
            renderKPIBlocks(kpis);
        });
    }

    var arrowUpSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" class="size-8 shrink-0">' +
        '<path d="M22.666 9.3335L9.33268 9.3335M22.666 9.3335L22.666 22.6668M22.666 9.3335L9.33268 22.6668" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";

    var arrowDownSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" class="size-8 shrink-0">' +
        '<path d="M9.33398 22.6665L22.6673 22.6665M9.33398 22.6665L9.33398 9.33317M9.33398 22.6665L22.6673 9.33317" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";

    function renderKPIBlocks(kpis) {
        var $container = $("#kpi-blocks");
        $container.empty();

        if (!kpis.length) {
            $container.addClass("hidden");
            return;
        }

        kpis.forEach(function (kpi) {
            var html;

            if (kpi.groups && kpi.groups.length) {
                // Grouped KPI card
                var rows = kpi.groups
                    .map(function (g) {
                        return (
                            '<div class="flex items-center justify-between gap-4 py-2 border-b border-blue-05 last:border-0">' +
                            '<span class="text-14 text-grey-03 leading-5">' +
                            escHtml(g.label) +
                            "</span>" +
                            '<span class="text-20 font-bold text-grey-01 leading-7 tabular-nums">' +
                            formatNumber(g.value) +
                            "</span>" +
                            "</div>"
                        );
                    })
                    .join("");

                html =
                    '<div class="bg-white rounded-2xl p-6 flex flex-col gap-4">' +
                    '<p class="text-12 font-bold uppercase text-grey-03 leading-4">' +
                    escHtml(kpi.title) +
                    "</p>" +
                    '<div class="flex flex-col">' +
                    rows +
                    "</div>" +
                    "</div>";
            } else {
                // Single-value KPI card
                var indicatorHtml = "";
                if (kpi.change !== null) {
                    var isUp = kpi.direction === "up";
                    var isDown = kpi.direction === "down";
                    var arrow = isUp ? arrowUpSvg : isDown ? arrowDownSvg : "";
                    var colorCls = isUp ? "text-primary" : isDown ? "text-red" : "text-grey-03";
                    indicatorHtml =
                        '<div class="flex items-center gap-1 ' +
                        colorCls +
                        '">' +
                        arrow +
                        '<div class="flex items-baseline gap-1 whitespace-nowrap">' +
                        '<span class="text-16 leading-6">' +
                        Math.abs(kpi.change) +
                        "%</span>" +
                        '<span class="text-12 font-bold text-[#8782cf] uppercase leading-4"> ' +
                        i18n.vs +
                        "</span>" +
                        "</div>" +
                        "</div>";
                } else if (kpi.prev === 0 && kpi.value > 0) {
                    indicatorHtml =
                        '<div class="flex items-center gap-1 text-primary">' +
                        arrowUpSvg +
                        '<span class="text-12 font-bold uppercase leading-4">' +
                        i18n.novo +
                        "</span>" +
                        "</div>";
                }

                html =
                    '<div class="bg-white rounded-2xl p-6 flex items-start justify-between gap-4">' +
                    '<div class="flex flex-col gap-1">' +
                    '<p class="text-56 text-grey-01 leading-16">' +
                    formatNumber(kpi.value) +
                    "</p>" +
                    '<p class="text-12 text-grey-03 leading-4">' +
                    escHtml(kpi.title) +
                    "</p>" +
                    "</div>" +
                    indicatorHtml +
                    "</div>";
            }

            $container.append(html);
        });
    }

    // ── Tabs nav ──────────────────────────────────────────────────────────────

    function renderTabsNav() {
        var $nav = $("#indicators-tabs-nav");
        $nav.empty();

        state.tabs.forEach(function (tab) {
            var $btn = $(
                '<button type="button" class="ind-tab-btn shrink-0 px-4 pb-3 text-14 font-bold uppercase border-b-[3px] -mb-px transition whitespace-nowrap">'
            )
                .text(tab.title)
                .attr("data-tab-id", tab.id);
            $nav.append($btn);
        });
    }

    function getTabCookie() {
        var match = document.cookie.match(/(?:^|;\s*)hcp_ind_tab=(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    }

    function setTabCookie(tabId) {
        document.cookie = "hcp_ind_tab=" + tabId + "; path=/; max-age=3600";
    }

    function saveFiltersCookie() {
        try {
            var ffClean = Object.assign({}, state.filters.fieldFilters);
            delete ffClean["__et__"];
            var data = {
                years: state.filters.years,
                entity_types: state.filters.entityTypes,
                field_filters: ffClean,
            };
            document.cookie = "hcp_ind_filters=" + encodeURIComponent(JSON.stringify(data)) + "; path=/; max-age=3600";
        } catch (e) {}
    }

    function loadFiltersCookie() {
        var match = document.cookie.match(/(?:^|;\s*)hcp_ind_filters=([^;]+)/);
        if (!match) return null;
        try {
            return JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            return null;
        }
    }

    function activateTab(tabId) {
        state.activeTab = parseInt(tabId, 10);
        setTabCookie(state.activeTab);

        var $activeBtn = null;
        $("#indicators-tabs-nav .ind-tab-btn").each(function () {
            var isActive = parseInt($(this).data("tab-id"), 10) === state.activeTab;
            $(this).toggleClass("border-primary text-primary", isActive);
            $(this).toggleClass("border-transparent text-grey-03 hover:text-grey-01", !isActive);
            if (isActive) $activeBtn = $(this);
        });
        if ($activeBtn) {
            $activeBtn[0].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
        }

        renderTabPanel(state.activeTab);
    }

    $(document).on("click", ".ind-tab-btn", function () {
        activateTab($(this).data("tab-id"));
    });

    // ── Tab panels ────────────────────────────────────────────────────────────

    function renderTabPanel(tabId) {
        var tab = state.tabs.find(function (t) {
            return parseInt(t.id, 10) === parseInt(tabId, 10);
        });
        if (!tab) return;

        (tab.charts || []).forEach(function (chart) {
            if (state.chartObjs[chart.id]) {
                state.chartObjs[chart.id].destroy();
                delete state.chartObjs[chart.id];
            }
        });

        var $panels = $("#indicators-tab-panels");
        $panels.empty();
        $("#ind-loading").hide();

        if (!tab.charts || !tab.charts.length) {
            $panels.html('<p class="text-grey-03 text-center py-10">' + i18n.noData + "</p>");
            return;
        }

        var $grid = $('<div class="grid grid-cols-1 lg:grid-cols-2 gap-5">');

        tab.charts.forEach(function (chart) {
            var $card = buildChartCard(chart);
            $grid.append($card);
        });

        // Per-tab download button
        var $tabDlBtn = $(
            '<button type="button" class="btn-download-tab hcp-button fill icon opacity-30 cursor-not-allowed" disabled>' +
                i18n.downloadAllPdf +
                downloadIconSvg +
                "</button>"
        );
        var $buttonWrapper = $('<div class="flex justify-center mt-4">').append($tabDlBtn);
        $tabDlBtn.on("click", function () {
            downloadAllChartsPDF($(this), tab);
        });
        $panels.append($grid);
        $panels.append($buttonWrapper);

        state.renderGen++;
        var myGen = state.renderGen;
        tab.charts.forEach(function (chart) {
            fetchAndRenderChart(chart, myGen);
        });
    }

    var downloadIconSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-6 shrink-0">' +
        '<path d="M12 3v13m0 0l-4-4m4 4l4-4M3 17v2a2 2 0 002 2h14a2 2 0 002-2v-2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";

    var infoIconSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5">' +
        '<circle cx="12" cy="12" r="10"/>' +
        '<line x1="12" y1="8" x2="12" y2="8" stroke-width="2"/>' +
        '<line x1="12" y1="12" x2="12" y2="16"/>' +
        "</svg>";

    function buildChartCard(chart) {
        var canvasId = "chart-canvas-" + chart.id;
        var downloadBtn = "";
        if (parseInt(chart.allow_download, 10) !== 0) {
            downloadBtn =
                '<button type="button" class="btn-download-chart cursor-pointer flex items-center gap-3 text-primary text-16 leading-6 font-medium hover:text-blue-01 transition-colors shrink-0" data-chart-id="' +
                chart.id +
                '">' +
                i18n.downloadPdf +
                downloadIconSvg +
                "</button>";
        }

        var hasInfo = !!(chart.about || chart.legend_json);
        var infoPopover = "";
        if (hasInfo) {
            var aboutHtml = chart.about
                ? '<p class="text-14 text-grey-03 leading-5 mt-2">' + escHtml(chart.about) + "</p>"
                : "";
            var legendSourceHtml = chart.legend_json
                ? '<p class="text-14 text-grey-03 leading-5 mt-3 pt-3 border-t border-blue-05" style="font-size:12px;opacity:.75">' +
                  escHtml(chart.legend_json) +
                  "</p>"
                : "";
            infoPopover =
                '<div class="chart-info-trigger relative shrink-0 self-start">' +
                '<button type="button" class="chart-info-btn text-primary opacity-60 hover:opacity-100 transition-opacity p-0.5 rounded-full" aria-label="' +
                escHtml(i18n.aboutChart || "Sobre este gráfico") +
                '">' +
                infoIconSvg +
                "</button>" +
                '<div class="chart-info-popover absolute right-0 top-full mt-2 bg-white border border-blue-05 rounded-2xl shadow-lg p-5 z-50" style="display:none;width:280px;max-width:90vw">' +
                '<p class="text-14 font-semibold text-grey-01 leading-5">' +
                escHtml(i18n.aboutChart || "Sobre este gráfico") +
                "</p>" +
                aboutHtml +
                legendSourceHtml +
                "</div>" +
                "</div>";
        }

        var html =
            '<div class="bg-white rounded-2xl p-6 flex flex-col gap-8" data-chart-id="' +
            chart.id +
            '">' +
            '<div class="flex items-start justify-between gap-3 shrink-0">' +
            '<div class="flex flex-col gap-1 min-w-0">' +
            '<p class="text-20 text-grey-01 leading-8">' +
            escHtml(chart.title) +
            "</p>" +
            (chart.description
                ? '<p class="text-14 text-grey-03 leading-5">' + escHtml(chart.description) + "</p>"
                : "") +
            "</div>" +
            infoPopover +
            "</div>" +
            '<div class="flex-1 chart-loading flex items-center justify-center py-12">' +
            loadingSpinner +
            "</div>" +
            '<div class="flex items-center flex-1">' +
            '<canvas id="' +
            canvasId +
            '" class="hidden " style="max-height:380px"></canvas>' +
            "</div>" +
            '<div class="chart-footer flex items-center justify-end gap-4 shrink-0" style="opacity:0;transition:opacity .5s ease">' +
            downloadBtn +
            "</div>" +
            "</div>";

        var $card = $(html);

        if (hasInfo) {
            var $trigger = $card.find(".chart-info-trigger");
            var $btn = $trigger.find(".chart-info-btn");
            var $popover = $trigger.find(".chart-info-popover");
            var closeTimer;

            $btn.on("mouseenter", function () {
                clearTimeout(closeTimer);
                $popover.stop(true, true).fadeIn(150);
            });
            $btn.on("mouseleave", function () {
                closeTimer = setTimeout(function () {
                    $popover.stop(true, true).fadeOut(150);
                }, 120);
            });
            $popover.on("mouseenter", function () {
                clearTimeout(closeTimer);
            });
            $popover.on("mouseleave", function () {
                closeTimer = setTimeout(function () {
                    $popover.stop(true, true).fadeOut(150);
                }, 120);
            });
            $btn.on("click", function (e) {
                e.stopPropagation();
                $popover.is(":visible")
                    ? $popover.stop(true, true).fadeOut(150)
                    : $popover.stop(true, true).fadeIn(150);
            });
            $(document)
                .off("click.chart-info-" + chart.id)
                .on("click.chart-info-" + chart.id, function () {
                    $popover.stop(true, true).fadeOut(150);
                });
        }

        return $card;
    }

    function fetchAndRenderChart(chart, gen) {
        // Disabled chart: skip data fetch and show the replacement label using
        // the same layout as the "no data" state.
        if (parseInt(chart.is_disabled, 10) === 1) {
            var $disabledCard = $('[data-chart-id="' + chart.id + '"]');
            $disabledCard
                .find(".chart-loading")
                .text(chart.disabled_label || i18n.noData)
                .show();
            $disabledCard.find("canvas").addClass("hidden");
            return;
        }

        // Strip the virtual __et__ field before sending — entity types go via entity_types param
        var fieldFiltersClean = Object.assign({}, state.filters.fieldFilters);
        delete fieldFiltersClean["__et__"];

        pendingChartCount++;

        post(
            "hcp_ind_get_chart_data",
            {
                chart_id: chart.id,
                years: state.filters.years,
                entity_types: state.filters.entityTypes,
                field_filters_json: JSON.stringify(fieldFiltersClean),
            },
            function (data) {
                pendingChartCount = Math.max(0, pendingChartCount - 1);
                if (applyLoadingActive) {
                    setApplyLoading(false);
                }
                if (pendingChartCount === 0) {
                    $(".btn-download-tab")
                        .prop("disabled", false)
                        .removeClass("opacity-30 cursor-not-allowed")
                        .addClass("cursor-pointer");
                }
                if (gen !== undefined && gen !== state.renderGen) {
                    return;
                }
                renderChart(chart, data);
            }
        );
    }

    var PALETTE = [
        // 1ª volta (máximo contraste)
        "#1A8C8C",
        "#B85472",
        "#4A7C59",
        "#5B7FA6",
        "#C07A3A",
        "#8A6AB5",
        // 2ª volta (variações equilibradas)
        "#20AFAF",
        "#CC8399",
        "#5C9B6F",
        "#85A0BD",
        "#D19A67",
        "#B09ACD",
        // 3ª volta (escuros)
        "#146969",
        "#8E3B54",
        "#385D43",
        "#445F7D",
        "#905C2B",
        "#664790",
        // 4ª volta (claros)
        "#27D2D2",
        "#DFB3C0",
        "#7AAF8A",
        "#AEC0D3",
        "#E0BA97",
        "#D5CAE5",
    ];

    var GRID_COLOR = "#D3D7DE";
    var TICK_COLOR = "#575E67";
    var TICK_FONT = { size: 12, weight: "bold" };

    if (typeof Chart !== "undefined" && Chart.Tooltip && Chart.Tooltip.positioners) {
        Chart.Tooltip.positioners.cursor = function (elements, eventPosition) {
            return { x: eventPosition.x, y: eventPosition.y };
        };
    }

    function hexToRgba(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16);
        var g = parseInt(hex.slice(3, 5), 16);
        var b = parseInt(hex.slice(5, 7), 16);
        return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    }

    function tickOpts(extra) {
        return Object.assign({ color: TICK_COLOR, font: TICK_FONT, autoSkip: false }, extra || {});
    }

    function numericTickOpts(extra) {
        return tickOpts(
            Object.assign(
                {
                    callback: function (value) {
                        return formatNumber(value);
                    },
                },
                extra || {}
            )
        );
    }

    function gridOpts(show) {
        return { display: show !== false, color: GRID_COLOR, drawBorder: false };
    }

    // ── Shared helpers (used by all render functions) ─────────────────────────
    function axisTitleOpts(label) {
        if (!label) return {};
        return { title: { display: true, text: label, color: TICK_COLOR, font: TICK_FONT } };
    }

    // ── Shared dropdown builder (used by renderChart + renderGroupedStackedChart) ──
    function buildAddDropdown(items, onAdd) {
        var $addWrap = $('<div class="chart-add-series-wrap relative inline-block pt-2 pb-1"></div>');
        var $trigger = $(
            '<button type="button" class="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg border border-gray-200 bg-white text-gray-500 hover:border-gray-400 hover:text-gray-700 transition-colors shadow-sm">' +
                '<svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>' +
                "Adicionar série" +
                "</button>"
        );
        var $menu = $(
            '<div class="chart-add-series-menu absolute bottom-full left-0 mb-1 bg-white border border-gray-200 rounded-xl shadow-lg py-1 z-10 min-w-48 overflow-y-auto" style="display:none;max-height:320px"></div>'
        );
        items.forEach(function (item) {
            var bg = item.color || "#94a3b8";
            var $i = $(
                '<button type="button" class="w-full text-left flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">' +
                    '<span class="inline-block w-2.5 h-2.5 rounded-full shrink-0" style="background:' +
                    bg +
                    '"></span>' +
                    "<span>" +
                    escHtml(item.label) +
                    "</span>" +
                    "</button>"
            );
            (function ($btn) {
                $btn.on("click", function () {
                    onAdd(item);
                    $btn.remove();
                    if ($menu.find("button").length === 0) {
                        $addWrap.remove();
                    }
                });
            })($i);
            $menu.append($i);
        });
        $trigger.on("click", function (e) {
            e.stopPropagation();
            $menu.toggle();
        });
        $addWrap.append($trigger).append($menu);
        return $addWrap;
    }

    function renderGroupedStackedChart(chart, data, $card, $canvas) {
        var rawGroups = data.groups || [];
        var rawLabels = data.labels || [];

        // ── initial_visible_series: filter groups, pool the rest ─────────
        var initVisible = parseInt(chart.initial_visible_series, 10);
        var poolGroupItems = [];

        // Snapshot full original data so we can rebuild correctly on each add
        var _fullGroups = rawGroups.slice();
        var _fullLabels = rawLabels.slice();
        var _fullDsBase = data.datasets || [];
        var _fullDsData = _fullDsBase.map(function (ds) {
            return (ds.data || []).slice();
        });
        var _groupTotals = null; // set inside initVisible block, used by _buildDataForGroups

        // Builds a clean data object for a given set of group indices (sorted by total value desc)
        function _buildDataForGroups(idxSet) {
            var sorted = Object.keys(idxSet).map(Number);
            if (_groupTotals) {
                sorted.sort(function (a, b) {
                    return _groupTotals[b] - _groupTotals[a];
                });
            } else {
                sorted.sort(function (a, b) {
                    return a - b;
                });
            }
            var ng = [],
                nl = [];
            var nd = _fullDsBase.map(function (ds) {
                return Object.assign({}, ds, { data: [] });
            });
            sorted.forEach(function (i) {
                var grp = _fullGroups[i];
                var ns = nl.length;
                ng.push({ label: grp.label, start: ns, count: grp.count });
                for (var k = grp.start; k < grp.start + grp.count; k++) {
                    nl.push(_fullLabels[k]);
                    nd.forEach(function (d, di) {
                        d.data.push(_fullDsData[di][k] || 0);
                    });
                }
            });
            return Object.assign({}, data, { groups: ng, labels: nl, datasets: nd });
        }

        if (initVisible > 0 && rawGroups.length > initVisible) {
            // Compute per-group totals (stored in outer scope for _buildDataForGroups)
            var groupTotals = _fullGroups.map(function (grp) {
                var t = 0;
                _fullDsData.forEach(function (d) {
                    for (var k = grp.start; k < grp.start + grp.count; k++) {
                        t += typeof d[k] === "number" ? d[k] : 0;
                    }
                });
                return t;
            });

            _groupTotals = groupTotals; // expose to _buildDataForGroups closure

            var gi = _fullGroups.map(function (_, i) {
                return i;
            });
            gi.sort(function (a, b) {
                return groupTotals[b] - groupTotals[a];
            });

            // Active set (object used as mutable set, shared with dropdown closure)
            var _activeSet = {};
            gi.slice(0, initVisible).forEach(function (i) {
                _activeSet[i] = true;
            });

            // Pool items sorted desc by total
            poolGroupItems = gi.slice(initVisible).map(function (i) {
                return { label: _fullGroups[i].label, total: groupTotals[i], color: PALETTE[0], origIdx: i };
            });
            poolGroupItems.sort(function (a, b) {
                return b.total - a.total;
            });

            var filteredData = _buildDataForGroups(_activeSet);
            rawGroups = filteredData.groups;
            rawLabels = filteredData.labels;
            data = filteredData;
        }

        // Build spaced labels/data: insert one null spacer between groups
        var spacedLabels = [];
        var spacerPositions = {};
        var spacedGroups = [];
        var offset = 0;

        rawGroups.forEach(function (group, gi) {
            if (gi > 0) {
                spacedLabels.push("");
                spacerPositions[spacedLabels.length - 1] = true;
                offset++;
            }
            spacedGroups.push({ label: group.label, start: group.start + offset, count: group.count });
            for (var i = 0; i < group.count; i++) {
                var origIdx = group.start + i;
                var parts = rawLabels[origIdx].replace(/\s+/g, " ").trim().split(" ");
                spacedLabels.push(parts[parts.length - 1]);
            }
        });

        var spacedDatasets = (data.datasets || []).map(function (ds, i) {
            var color = PALETTE[i % PALETTE.length];
            var origData = ds.data || [];
            var newData = [];
            var rawIdx = 0;
            spacedLabels.forEach(function (_, pos) {
                if (spacerPositions[pos]) {
                    newData.push(null);
                } else {
                    newData.push(origData[rawIdx++] ?? 0);
                }
            });
            return {
                label: ds.label,
                data: newData,
                backgroundColor: ds.backgroundColor ? hexToRgba(ds.backgroundColor, 0.85) : hexToRgba(color, 0.85),
                borderColor: ds.backgroundColor || color,
                borderWidth: 0,
                stack: ds.stack || "stack",
                skipNull: true,
                maxBarThickness: 22,
            };
        });

        // Per-year colors for field_options_by_year: cycle PALETTE by position within each group
        var yearLegendLabels = null;
        if (data.chart_variant === "field_options_by_year" && rawGroups.length > 0) {
            var yearCount = rawGroups[0].count;
            yearLegendLabels = [];
            if (spacedGroups.length > 0) {
                for (var yi = 0; yi < yearCount; yi++) {
                    yearLegendLabels.push(spacedLabels[spacedGroups[0].start + yi] || String(yi));
                }
            }
            spacedDatasets = spacedDatasets.map(function (ds) {
                var bgArr = [],
                    borderArr = [],
                    yIdx = 0;
                spacedLabels.forEach(function (_, pos) {
                    if (spacerPositions[pos]) {
                        bgArr.push("transparent");
                        borderArr.push("transparent");
                        yIdx = 0;
                    } else {
                        var c = PALETTE[yIdx % yearCount];
                        bgArr.push(hexToRgba(c, 0.85));
                        borderArr.push(c);
                        yIdx++;
                    }
                });
                return Object.assign({}, ds, { backgroundColor: bgArr, borderColor: borderArr });
            });
        }

        var horizGroupLabels = spacedGroups.length <= 4;

        var groupLabelsPlugin = {
            id: "groupLabels-" + chart.id,
            afterDraw: function (chartObj) {
                if (!spacedGroups.length) return;
                var ctx = chartObj.ctx;
                var xAxis = chartObj.scales.x;
                var yBottom = chartObj.scales.y.bottom;
                var stepPx = Math.abs(xAxis.getPixelForValue(1) - xAxis.getPixelForValue(0));

                ctx.save();
                ctx.font = "12px Arial, sans-serif";
                ctx.fillStyle = TICK_COLOR;
                ctx.textBaseline = "top";

                spacedGroups.forEach(function (group) {
                    var startX = xAxis.getPixelForValue(group.start) - stepPx * 0.5;
                    var endX = xAxis.getPixelForValue(group.start + group.count - 1) + stepPx * 0.5;
                    var centerX = (startX + endX) / 2;

                    if (horizGroupLabels) {
                        ctx.textAlign = "center";
                        var maxW = Math.max(endX - startX - 4, 40);
                        var words = group.label.split(" ");
                        var lines = [];
                        var cur = "";
                        words.forEach(function (w) {
                            var test = cur ? cur + " " + w : w;
                            if (cur && ctx.measureText(test).width > maxW) {
                                lines.push(cur);
                                cur = w;
                            } else {
                                cur = test;
                            }
                        });
                        if (cur) lines.push(cur);
                        var lineH = 16;
                        lines.forEach(function (line, i) {
                            ctx.fillText(line, centerX, yBottom + 10 + i * lineH);
                        });
                    } else {
                        ctx.save();
                        ctx.textAlign = "right";
                        ctx.textBaseline = "middle";
                        ctx.translate(centerX, yBottom + 8);
                        ctx.rotate(-Math.PI / 4);
                        ctx.fillText(group.label, 0, 0);
                        ctx.restore();
                    }
                });

                ctx.restore();
            },
        };

        var bottomPad = horizGroupLabels ? 70 : 110;
        $canvas.css({
            height: horizGroupLabels ? "420px" : "470px",
            "max-height": horizGroupLabels ? "420px" : "470px",
            width: "100%",
        });

        var chartInstance = new Chart($canvas[0].getContext("2d"), {
            type: "bar",
            data: { labels: spacedLabels, datasets: spacedDatasets },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: { bottom: bottomPad, left: 8, right: 8 } },
                plugins: {
                    legend: {
                        display: yearLegendLabels ? yearLegendLabels.length > 1 : spacedDatasets.length > 1,
                        position: "bottom",
                        labels: Object.assign(
                            {
                                usePointStyle: true,
                                pointStyle: "circle",
                                boxWidth: 8,
                                boxHeight: 8,
                                color: TICK_COLOR,
                                font: TICK_FONT,
                                padding: 16,
                            },
                            yearLegendLabels
                                ? {
                                      generateLabels: function () {
                                          return yearLegendLabels.map(function (lbl, i) {
                                              var c = hexToRgba(PALETTE[i % PALETTE.length], 0.85);
                                              return {
                                                  text: lbl,
                                                  fillStyle: c,
                                                  strokeStyle: c,
                                                  lineWidth: 0,
                                                  pointStyle: "circle",
                                                  hidden: false,
                                              };
                                          });
                                      },
                                  }
                                : {}
                        ),
                    },
                    tooltip: {
                        mode: "index",
                        intersect: true,
                        position: "cursor",
                        filter: function (item) {
                            return item.raw !== null && item.raw !== 0;
                        },
                        callbacks: {
                            title: function () {
                                return "";
                            },
                            label: function (item) {
                                var pos = item.dataIndex;
                                var group = spacedGroups.find(function (g) {
                                    return pos >= g.start && pos < g.start + g.count;
                                });
                                var spacersBefore = Object.keys(spacerPositions).filter(function (sp) {
                                    return parseInt(sp, 10) < pos;
                                }).length;
                                var fullLabel = rawLabels[pos - spacersBefore] || spacedLabels[pos];
                                var ctx = (group ? group.label + " — " : "") + (fullLabel ? fullLabel + " — " : "");
                                return wrapTip(
                                    ctx +
                                        (item.dataset.label ? item.dataset.label + ": " : "") +
                                        formatNumber(item.raw),
                                    40
                                );
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        stacked: true,
                        grid: gridOpts(false),
                        ticks: tickOpts({
                            maxRotation: 0,
                            autoSkip: false,
                            callback: function () {
                                return "";
                            },
                        }),
                    },
                    y: Object.assign(
                        { stacked: true, beginAtZero: true, grid: gridOpts(), ticks: numericTickOpts() },
                        axisTitleOpts(chart.y_axis_label || "")
                    ),
                },
            },
            plugins: [groupLabelsPlugin],
        });

        state.chartObjs[chart.id] = chartInstance;

        // Dropdown to add pooled groups (re-renders chart to get correct position + colors)
        if (poolGroupItems.length > 0) {
            function _attachGroupDropdown() {
                if (!poolGroupItems.length) return;
                var $grpDropdown = buildAddDropdown(poolGroupItems, function (item) {
                    // Move item from pool to active set
                    _activeSet[item.origIdx] = true;
                    poolGroupItems.splice(poolGroupItems.indexOf(item), 1);

                    // Destroy current chart
                    if (state.chartObjs[chart.id]) {
                        state.chartObjs[chart.id].destroy();
                        delete state.chartObjs[chart.id];
                    }
                    $card.find(".chart-add-series-wrap").remove();

                    // Re-render with updated data (initial_visible_series=0 to skip re-filtering)
                    var chartNoFilter = Object.assign({}, chart, { initial_visible_series: 0 });
                    renderGroupedStackedChart(chartNoFilter, _buildDataForGroups(_activeSet), $card, $canvas);

                    // Re-attach dropdown with remaining pool items
                    _attachGroupDropdown();
                });
                $card.find(".chart-footer").before($grpDropdown);
            }
            _attachGroupDropdown();
        }

        $card.find(".chart-footer").css("opacity", "1");
        $card
            .find(".btn-download-chart")
            .off("click")
            .on("click", function () {
                downloadChartPDF(chart, data, chartInstance, $(this));
            });
    }

    function renderGroupedStackedChartHorizontal(chart, data, $card, $canvas) {
        var rawGroups = data.groups || [];
        var rawLabels = data.labels || [];

        // When groups exist but labels have no pre-embedded spacers (e.g. field_options_by_year
        // routed here for horizontal orientation), apply the same JS-side spacing as the vertical
        // variant does, then fall through to the normal pre-spaced path.
        var needsSpacing =
            rawGroups.length > 1 &&
            !rawLabels.some(function (l) {
                return l === "";
            });
        if (needsSpacing) {
            var newLabels = [];
            var newGroupsRaw = [];
            var offset = 0;
            rawGroups.forEach(function (group, gi) {
                if (gi > 0) {
                    newLabels.push("");
                    offset++;
                }
                newGroupsRaw.push({ label: group.label, start: group.start + offset, count: group.count });
                for (var i = 0; i < group.count; i++) {
                    var parts = (rawLabels[group.start + i] || "").replace(/\s+/g, " ").trim().split(" ");
                    newLabels.push(parts[parts.length - 1]);
                }
            });
            var spacerSet = {};
            newLabels.forEach(function (l, i) {
                if (l === "") spacerSet[i] = true;
            });
            var newDatasets = (data.datasets || []).map(function (ds) {
                var origData = ds.data || [];
                var nd = [];
                var rawIdx = 0;
                newLabels.forEach(function (_, pos) {
                    nd.push(spacerSet[pos] ? null : (origData[rawIdx++] ?? 0));
                });
                return Object.assign({}, ds, { data: nd });
            });
            data = Object.assign({}, data, { labels: newLabels, groups: newGroupsRaw, datasets: newDatasets });
            rawGroups = newGroupsRaw;
            rawLabels = newLabels;
        }

        // PHP already embeds spacers (empty strings) in labels and nulls in dataset data.
        // Use them directly — no re-spacing needed.
        var spacedLabels = rawLabels.slice();
        var spacerPositions = {};
        rawLabels.forEach(function (lbl, i) {
            if (lbl === "") spacerPositions[i] = true;
        });
        var spacedGroups = rawGroups.map(function (g) {
            return { label: g.label, start: g.start, count: g.count };
        });

        var spacedDatasets = (data.datasets || []).map(function (ds, i) {
            var color = ds.backgroundColor || PALETTE[i % PALETTE.length];
            return {
                label: ds.label,
                data: (ds.data || []).slice(),
                backgroundColor: hexToRgba(color, 0.85),
                borderColor: color,
                borderWidth: 0,
                stack: ds.stack || "stack",
                skipNull: true,
            };
        });

        var GROUP_LABEL_PAD = 90;

        var groupLabelsHPlugin = {
            id: "groupLabelsH-" + chart.id,
            afterDraw: function (chartObj) {
                if (!spacedGroups.length) return;
                var ctx = chartObj.ctx;
                var yScale = chartObj.scales.y;
                var stepPx = Math.abs(yScale.getPixelForValue(1) - yScale.getPixelForValue(0));
                var xLeft = chartObj.chartArea.left;

                spacedGroups.forEach(function (group, gi) {
                    var startY = yScale.getPixelForValue(group.start) - stepPx * 0.5;
                    var endY = yScale.getPixelForValue(group.start + group.count - 1) + stepPx * 0.5;
                    var centerY = (startY + endY) / 2;

                    if (gi > 0) {
                        ctx.save();
                        ctx.strokeStyle = "#e5e7eb";
                        ctx.lineWidth = 1;
                        ctx.setLineDash([]);
                        ctx.beginPath();
                        ctx.moveTo(xLeft - GROUP_LABEL_PAD, startY - stepPx * 0.5);
                        ctx.lineTo(chartObj.chartArea.right, startY - stepPx * 0.5);
                        ctx.stroke();
                        ctx.restore();
                    }

                    ctx.save();
                    ctx.font = "bold 11px Arial, sans-serif";
                    ctx.fillStyle = TICK_COLOR;
                    ctx.textAlign = "left";
                    ctx.textBaseline = "middle";
                    var maxPx = GROUP_LABEL_PAD - 8;
                    var label = group.label;
                    while (label.length > 4 && ctx.measureText(label).width > maxPx) {
                        label = label.slice(0, -2) + "\u2026";
                    }
                    ctx.fillText(label, xLeft - GROUP_LABEL_PAD + 4, centerY);
                    ctx.restore();
                });
            },
        };

        var spacerCount = Object.keys(spacerPositions).length;
        var dataRows = spacedLabels.length - spacerCount;
        var canvasH = Math.max(300, dataRows * 42 + spacerCount * 18 + 100);
        $canvas.css({ height: canvasH + "px", "max-height": "none", width: "100%" });

        var chartInstance = new Chart($canvas[0].getContext("2d"), {
            type: "bar",
            data: { labels: spacedLabels, datasets: spacedDatasets },
            options: {
                indexAxis: "y",
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: { left: spacedGroups.length ? GROUP_LABEL_PAD : 8 } },
                plugins: {
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            usePointStyle: true,
                            pointStyle: "circle",
                            boxWidth: 8,
                            boxHeight: 8,
                            color: TICK_COLOR,
                            font: TICK_FONT,
                            padding: 16,
                        },
                    },
                    tooltip: {
                        mode: "index",
                        intersect: true,
                        position: "cursor",
                        filter: function (item) {
                            return item.raw !== null && item.raw !== 0;
                        },
                        callbacks: {
                            title: function () {
                                return "";
                            },
                            label: function (item) {
                                var pos = item.dataIndex;
                                var group = spacedGroups.find(function (g) {
                                    return pos >= g.start && pos < g.start + g.count;
                                });
                                var rowLabel = spacedLabels[pos] || "";
                                var ctx =
                                    (group ? group.label + " \u2014 " : "") + (rowLabel ? rowLabel + " \u2014 " : "");
                                return wrapTip(
                                    ctx +
                                        (item.dataset.label ? item.dataset.label + ": " : "") +
                                        formatNumber(item.raw),
                                    40
                                );
                            },
                        },
                    },
                },
                scales: {
                    x: Object.assign(
                        { beginAtZero: true, stacked: true, grid: gridOpts(), ticks: numericTickOpts() },
                        axisTitleOpts(chart.y_axis_label || "")
                    ),
                    y: Object.assign(
                        {
                            stacked: true,
                            grid: gridOpts(false),
                            ticks: tickOpts({
                                callback: function (val, index) {
                                    return spacerPositions[index] ? "" : this.getLabelForValue(val);
                                },
                            }),
                        },
                        axisTitleOpts(chart.x_axis_label || "")
                    ),
                },
            },
            plugins: [groupLabelsHPlugin],
        });

        state.chartObjs[chart.id] = chartInstance;
        $card.find(".chart-footer").css("opacity", "1");
        $card
            .find(".btn-download-chart")
            .off("click")
            .on("click", function () {
                downloadChartPDF(chart, data, chartInstance, $(this));
            });
    }

    function renderChart(chart, data) {
        var canvasId = "chart-canvas-" + chart.id;
        var $card = $('[data-chart-id="' + chart.id + '"]');
        var $canvas = $("#" + canvasId);

        // Tab switched while AJAX was in-flight — canvas no longer in DOM
        if (!$canvas.length || !$card.length) return;

        var $loading = $card.find(".chart-loading");

        $loading.hide();
        $canvas.removeClass("hidden");

        if (state.chartObjs[chart.id]) {
            state.chartObjs[chart.id].destroy();
        }

        if (!data.labels || !data.labels.length || !data.datasets || !data.datasets.length) {
            $loading.text(data.pending_update_notice || i18n.noData).show();
            $canvas.addClass("hidden");
            return;
        }

        if (data.chart_variant === "field_group_horizontal") {
            renderGroupedStackedChartHorizontal(chart, data, $card, $canvas);
            return;
        }

        if (
            data.chart_variant === "field_options_by_entity_type" ||
            data.chart_variant === "field_group_by_year_entity_type" ||
            data.chart_variant === "field_options_by_year"
        ) {
            var ct0 = chart.chart_type || "";
            if (ct0 === "bar_grouped_horizontal" || ct0 === "bar_stacked_horizontal") {
                renderGroupedStackedChartHorizontal(chart, data, $card, $canvas);
            } else {
                renderGroupedStackedChart(chart, data, $card, $canvas);
            }
            return;
        }

        if (data.chart_variant === "count_by_option_year_entity_type") {
            var ctVariant = chart.chart_type || "bar";
            if (ctVariant === "bar_stacked_horizontal") {
                renderGroupedStackedChartHorizontal(chart, data, $card, $canvas);
            } else {
                renderGroupedStackedChart(chart, data, $card, $canvas);
            }
            return;
        }

        // grouped_stacked_entity_type falls through to standard renderChart below
        // (bar_grouped with per-dataset stack= from backend + stacked y-axis)

        var ct = chart.chart_type || "bar";
        var isLine = ct === "line" || ct === "line_multi";

        // Eixo de ano com um único ano: o ano é redundante — esconde a label da categoria.
        // (mantém-se visível em multi-ano, ex.: gráficos "todos os anos").
        if (chart.x_axis === "year" && (data.labels || []).length === 1) {
            data = Object.assign({}, data, { labels: [""] });
        }

        // Line charts with a single selected year have no temporal axis — render as bar instead
        if (isLine && (data.labels || []).length <= 1) {
            isLine = false;
            if (ct === "line_multi") {
                // Transpose: series (datasets) → x-axis labels, year → single dataset label.
                // Ignora séries auxiliares (_avg/_trend) — não devem tornar-se barras.
                var yearLabel = data.labels && data.labels[0] != null ? String(data.labels[0]) : "";
                var realSeries = (data.datasets || []).filter(function (ds) {
                    return ds.label !== "_avg" && ds.label !== "_trend";
                });
                var transposedLabels = realSeries.map(function (ds) {
                    return ds.label || "";
                });
                var transposedValues = realSeries.map(function (ds) {
                    return (ds.data || [])[0] != null ? (ds.data || [])[0] : 0;
                });
                data = Object.assign({}, data, {
                    labels: transposedLabels,
                    datasets: [{ label: yearLabel, data: transposedValues }],
                });
            }
            ct = "bar";
        }

        var isStacked = ct === "bar_stacked";
        var isStackedH = ct === "bar_stacked_horizontal";
        var isGrouped = ct === "bar_grouped" || ct === "bar_grouped_horizontal";
        var isHorizontal = ct === "bar_horizontal";
        var isArea = ct === "area";
        var isPie = ct === "pie" || ct === "doughnut";
        var isMultiDs = isStacked || isStackedH || isGrouped;

        var type;
        if (isPie) {
            type = ct;
        } else if (isLine || isArea) {
            type = "line";
        } else {
            type = "bar";
        }

        // Grouped bar colapsado a uma única categoria (ex.: um único ano): pivota as
        // séries para o eixo das categorias — cada série fica uma barra com a sua label
        // (à esquerda, no horizontal), dispensando a legenda.
        var pivoted = false;
        if (isGrouped && (data.labels || []).length <= 1) {
            var pivotDs = (data.datasets || []).filter(function (ds) {
                return ds.label !== "_avg" && ds.label !== "_trend";
            });
            if (pivotDs.length > 1) {
                data = Object.assign({}, data, {
                    labels: pivotDs.map(function (ds) {
                        return ds.label || "";
                    }),
                    datasets: [
                        {
                            data: pivotDs.map(function (ds) {
                                return (ds.data || [])[0] != null ? ds.data[0] : 0;
                            }),
                            backgroundColor: pivotDs.map(function (ds, i) {
                                return ds.backgroundColor || PALETTE[i % PALETTE.length];
                            }),
                        },
                    ],
                });
                var keepH = isHorizontal || isStackedH || ct === "bar_grouped_horizontal";
                ct = keepH ? "bar_horizontal" : "bar";
                isStacked = false;
                isStackedH = false;
                isGrouped = false;
                isMultiDs = false;
                isHorizontal = keepH;
                type = "bar";
                pivoted = true;
            }
        }

        var datasets = (data.datasets || []).slice();

        if (isLine) {
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        borderColor: color,
                        backgroundColor: "transparent",
                        borderWidth: 2,
                        tension: 0.3,
                        fill: false,
                        pointRadius: 3,
                        pointHoverRadius: 5,
                    },
                    ds
                );
            });
        } else if (isArea) {
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        borderColor: color,
                        backgroundColor: hexToRgba(color, 0.35),
                        borderWidth: 2,
                        tension: 0.3,
                        fill: true,
                        pointRadius: 0,
                        pointHoverRadius: 4,
                    },
                    ds
                );
            });
        } else if (isGrouped) {
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        backgroundColor: color,
                        borderWidth: 0,
                        borderRadius: 0,
                        barPercentage: 1.0,
                        categoryPercentage: 0.7,
                    },
                    ds
                );
            });
        } else if (isMultiDs) {
            // isStacked / isStackedH — barPercentage fills the slot; categoryPercentage
            // leaves space between X categories (same visual rhythm as bar_grouped)
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        backgroundColor: color,
                        borderWidth: 0,
                        borderRadius: 0,
                        barPercentage: 1.0,
                        categoryPercentage: 0.7,
                        skipNull: false,
                    },
                    ds
                );
            });
        } else if (isPie) {
            if (datasets[0] && !datasets[0].backgroundColor) {
                datasets[0].backgroundColor = (datasets[0].data || []).map(function (_, i) {
                    return PALETTE[i % PALETTE.length];
                });
            }
        } else if (isHorizontal && datasets.length > 1) {
            // Multi-dataset horizontal (e.g. entity_type × year)
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        backgroundColor: hexToRgba(color, 0.85),
                        borderWidth: 0,
                        borderRadius: 0,
                        barPercentage: 0.8,
                        categoryPercentage: 0.9,
                    },
                    ds
                );
            });
        } else if (!isPie && datasets.length > 1) {
            // bar / bar_horizontal with multiple datasets → render grouped
            datasets = datasets.map(function (ds, i) {
                var color = PALETTE[i % PALETTE.length];
                return Object.assign(
                    {
                        backgroundColor: color,
                        borderWidth: 0,
                        borderRadius: 0,
                        barPercentage: 1.0,
                        categoryPercentage: 0.7,
                    },
                    ds
                );
            });
        } else {
            // bar, bar_horizontal — single dataset
            datasets = datasets.map(function (ds) {
                return Object.assign(
                    {
                        backgroundColor: PALETTE[0],
                        borderWidth: 0,
                        borderRadius: 0,
                        barPercentage: 0.6,
                    },
                    ds
                );
            });
        }

        // ── Trend line overlay ────────────────────────────────────────────────
        // The PHP backend appends a dataset with label='_trend' for line/area charts
        // when show_trend_line=1. Render it as a dashed line overlay.
        var trendDatasets = [];
        datasets = datasets.filter(function (ds) {
            if (ds.label === "_trend") {
                trendDatasets.push(ds);
                return false;
            }
            return true;
        });
        if (trendDatasets.length && (isLine || isArea)) {
            var trendColor = datasets[0] && datasets[0].borderColor ? datasets[0].borderColor : PALETTE[0];
            trendDatasets.forEach(function (td) {
                datasets.push(
                    Object.assign({}, td, {
                        type: "line",
                        label: hcpIndicatorsV2.i18n.trend,
                        borderColor: trendColor,
                        backgroundColor: "transparent",
                        borderWidth: 1.5,
                        borderDash: [5, 5],
                        pointRadius: 0,
                        pointHoverRadius: 0,
                        fill: false,
                        tension: 0,
                    })
                );
            });
        }

        // ── Average line overlay ──────────────────────────────────────────────
        // The PHP backend appends a dataset with label='_avg' (média por ano) for
        // line/area charts when show_avg_line=1. Render as a solid, distinct line.
        var avgDatasets = [];
        datasets = datasets.filter(function (ds) {
            if (ds.label === "_avg") {
                avgDatasets.push(ds);
                return false;
            }
            return true;
        });
        if (avgDatasets.length && (isLine || isArea)) {
            avgDatasets.forEach(function (ad) {
                datasets.push(
                    Object.assign({}, ad, {
                        type: "line",
                        label: hcpIndicatorsV2.i18n.avgLine,
                        borderColor: "#6D28D9",
                        backgroundColor: "transparent",
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 4,
                        fill: false,
                        tension: 0.3,
                    })
                );
            });
        }

        var xLabel = chart.x_axis_label || "";
        var yLabel = chart.y_axis_label || "";

        var scales;
        if (isPie) {
            scales = {};
        } else if (isArea || isLine) {
            scales = {
                x: Object.assign({ grid: gridOpts(), ticks: tickOpts() }, axisTitleOpts(xLabel)),
                y: Object.assign(
                    {
                        beginAtZero: true,
                        stacked: isArea && datasets.length > 1,
                        grid: gridOpts(),
                        ticks: numericTickOpts(),
                    },
                    axisTitleOpts(yLabel)
                ),
            };
        } else if (isStackedH) {
            // indexAxis=y but labels are positional: X field → visual X, Y field → visual Y
            scales = {
                x: Object.assign(
                    { beginAtZero: true, stacked: true, grid: gridOpts(), ticks: numericTickOpts() },
                    axisTitleOpts(xLabel)
                ),
                y: Object.assign({ stacked: true, grid: gridOpts(false), ticks: tickOpts() }, axisTitleOpts(yLabel)),
            };
        } else if (isStacked) {
            scales = {
                x: Object.assign({ stacked: true, grid: gridOpts(false), ticks: tickOpts() }, axisTitleOpts(xLabel)),
                y: Object.assign(
                    { beginAtZero: true, stacked: true, grid: gridOpts(), ticks: numericTickOpts() },
                    axisTitleOpts(yLabel)
                ),
            };
        } else if (isHorizontal) {
            // indexAxis=y but labels are positional: X field → visual X, Y field → visual Y
            scales = {
                x: Object.assign(
                    { beginAtZero: true, grid: gridOpts(), ticks: numericTickOpts() },
                    axisTitleOpts(xLabel)
                ),
                y: Object.assign({ grid: gridOpts(false), ticks: tickOpts() }, axisTitleOpts(yLabel)),
            };
        } else if (ct === "bar_grouped_horizontal") {
            // indexAxis=y but labels are positional: X field → visual X, Y field → visual Y
            scales = {
                x: Object.assign(
                    { beginAtZero: true, grid: gridOpts(), ticks: numericTickOpts() },
                    axisTitleOpts(xLabel)
                ),
                y: Object.assign({ grid: gridOpts(false), ticks: tickOpts() }, axisTitleOpts(yLabel)),
            };
        } else {
            // bar, bar_grouped (vertical)
            var labelCount = (data.labels || []).length;
            var rotationPadLeft = 0;
            var xTicks;
            if (chart.id === 20) {
                xTicks = tickOpts({ maxRotation: 90, minRotation: 90, padding: 8 });
            } else if (labelCount <= 4) {
                xTicks = tickOpts({
                    maxRotation: 0,
                    minRotation: 0,
                    callback: function (val) {
                        var lbl = this.getLabelForValue(val);
                        if (!lbl || lbl.length <= 16) return lbl;
                        var words = lbl.split(" ");
                        var lines = [];
                        var cur = "";
                        words.forEach(function (w) {
                            if (cur && (cur + " " + w).length > 16) {
                                lines.push(cur);
                                cur = w;
                            } else {
                                cur = cur ? cur + " " + w : w;
                            }
                        });
                        if (cur) lines.push(cur);
                        return lines;
                    },
                });
            } else {
                xTicks = tickOpts({ maxRotation: 45 });
                // Labels rodadas 45° estendem-se para a esquerda além da chartArea
                // e seriam cortadas. Mede a label mais larga e deriva o padding
                // horizontal necessário (extensão horizontal ≈ largura × cos45°).
                var measCtx = document.createElement("canvas").getContext("2d");
                measCtx.font = TICK_FONT.weight + " " + TICK_FONT.size + "px sans-serif";
                var maxLabelPx = 0;
                (data.labels || []).forEach(function (lbl) {
                    var w = measCtx.measureText(String(lbl)).width;
                    if (w > maxLabelPx) maxLabelPx = w;
                });
                rotationPadLeft = Math.max(8, Math.min(64, Math.round(maxLabelPx * 0.707)));
            }
            var isGroupedStackedET = data.chart_variant === "grouped_stacked_entity_type";
            scales = {
                x: Object.assign({ stacked: isGroupedStackedET, grid: gridOpts(false), ticks: xTicks }, axisTitleOpts(xLabel)),
                y: Object.assign(
                    { beginAtZero: true, stacked: isGroupedStackedET, grid: gridOpts(), ticks: numericTickOpts() },
                    axisTitleOpts(yLabel)
                ),
            };
        }

        var showLegend = isPie || datasets.length > 1;
        // Série = ano (group_axis="year") com um único ano → o ano é redundante na tooltip
        var singleYearSeries =
            chart.group_axis === "year" &&
            (data.datasets || []).filter(function (ds) {
                return ds.label !== "_avg" && ds.label !== "_trend";
            }).length <= 1;
        var chartOptions = {
            responsive: true,
            layout: rotationPadLeft ? { padding: { left: rotationPadLeft, right: 4 } } : undefined,
            plugins: {
                legend: {
                    display: showLegend,
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 8,
                        boxHeight: 8,
                        color: TICK_COLOR,
                        font: TICK_FONT,
                        padding: 16,
                    },
                },
                tooltip: {
                    intersect: true,
                    position: "cursor",
                    callbacks: {
                        title: function (items) {
                            if (!items.length) return "";
                            if (isPie && data.x_field_name) {
                                return wrapTip(data.x_field_name, 30);
                            }
                            return "";
                        },
                        label: function (item) {
                            var prefix;
                            if (isPie) {
                                prefix = item.label;
                            } else {
                                // Em eixos/séries de ano não prefixar com o ano — só série/valor
                                prefix =
                                    item.dataset.label ||
                                    (chart.x_axis === "year" && !pivoted ? "" : item.label);
                                if (singleYearSeries) prefix = "";
                            }
                            // Gráficos circulares com "Mostrar em percentagem": mostra a
                            // % do total em vez do valor absoluto.
                            if (isPie && parseInt(chart.show_percentage, 10) === 1) {
                                return wrapTip((prefix ? prefix + ": " : "") + formatPercent(item.raw, item.dataset.data), 30);
                            }
                            return wrapTip((prefix ? prefix + ": " : "") + formatNumber(item.raw), 30);
                        },
                    },
                },
            },
            scales: scales,
        };

        if (isHorizontal || isStackedH || ct === "bar_grouped_horizontal") {
            chartOptions.indexAxis = "y";
        }

        // ── initial_visible_series: two modes ────────────────────────────────
        // Mode A (multi-dataset): N datasets, each clinical area is a dataset series
        // Mode B (single-dataset): 1 dataset with N x-axis labels; filter labels instead
        var initVisible = parseInt(chart.initial_visible_series, 10);
        var poolDatasets = []; // mode A pool
        var poolLabels = []; // mode B pool: [{label, value, color}]

        if (initVisible > 0) {
            if (datasets.length > initVisible) {
                // ── Mode A: multiple datasets ────────────────────────────────
                var dsWithTotals = datasets.map(function (ds) {
                    var total = (ds.data || []).reduce(function (s, v) {
                        return s + (typeof v === "number" ? v : 0);
                    }, 0);
                    return { ds: ds, total: total };
                });
                dsWithTotals.sort(function (a, b) {
                    return b.total - a.total;
                });
                datasets = dsWithTotals.slice(0, initVisible).map(function (x) {
                    return x.ds;
                });
                poolDatasets = dsWithTotals.slice(initVisible).map(function (x) {
                    return x.ds;
                });
            } else if ((data.labels || []).length > initVisible) {
                // ── Mode B: filter x-axis labels (works for 1 or N datasets) ──
                // Each label[i] maps to ds.data[i] in every dataset.
                // Sort by total across all datasets so the top-N labels are shown.
                var allLabels = data.labels || [];
                var totalPerLabel = allLabels.map(function (lbl, i) {
                    return datasets.reduce(function (sum, ds) {
                        var v = (ds.data || [])[i];
                        return sum + (typeof v === "number" ? v : 0);
                    }, 0);
                });

                var labelIndices = allLabels.map(function (_, i) {
                    return i;
                });
                labelIndices.sort(function (a, b) {
                    return totalPerLabel[b] - totalPerLabel[a];
                });

                var activeIdx = labelIndices.slice(0, initVisible);
                var poolIdx = labelIndices.slice(initVisible);

                // Snapshot original data per dataset before slicing
                var dsColor0 =
                    (typeof datasets[0].backgroundColor === "string" ? datasets[0].backgroundColor : null) || "#00BFB2";
                var originalDsData = datasets.map(function (ds) {
                    return (ds.data || []).slice();
                });

                data = Object.assign({}, data, {
                    labels: activeIdx.map(function (i) {
                        return allLabels[i];
                    }),
                });
                datasets = datasets.map(function (ds, di) {
                    return Object.assign({}, ds, {
                        data: activeIdx.map(function (i) {
                            return originalDsData[di][i] || 0;
                        }),
                    });
                });

                // Build pool: each item carries per-dataset values for correct insertion
                poolIdx.forEach(function (i) {
                    poolLabels.push({
                        label: allLabels[i],
                        value: totalPerLabel[i],
                        color: dsColor0,
                        allData: originalDsData.map(function (dsArr) {
                            return dsArr[i] || 0;
                        }),
                    });
                });
            }
        }

        var chartInstance = new Chart($canvas[0].getContext("2d"), {
            type: type,
            data: { labels: data.labels, datasets: datasets },
            options: chartOptions,
        });

        state.chartObjs[chart.id] = chartInstance;

        // Remove any stale "add series" dropdown from a previous render
        $card.find(".chart-add-series-wrap").remove();

        // Render compact "add series" dropdown for pooled datasets
        if (poolDatasets.length > 0) {
            var poolA = poolDatasets.map(function (ds) {
                var bg =
                    (typeof ds.backgroundColor === "string" ? ds.backgroundColor : null) ||
                    (typeof ds.borderColor === "string" ? ds.borderColor : null) ||
                    "#94a3b8";
                return { label: ds.label, color: bg, _ds: ds };
            });
            var $wrapA = buildAddDropdown(poolA, function (item) {
                chartInstance.data.datasets.push(item._ds);
                chartInstance.update();
            });
            $card.find(".chart-footer").before($wrapA);
        }

        if (poolLabels.length > 0) {
            var $wrapB = buildAddDropdown(poolLabels, function (item) {
                chartInstance.data.labels.push(item.label);
                chartInstance.data.datasets.forEach(function (ds, di) {
                    ds.data.push(item.allData ? item.allData[di] || 0 : 0);
                });
                chartInstance.update();
            });
            $card.find(".chart-footer").before($wrapB);
        }

        $card.find(".chart-footer").css("opacity", "1");

        $card
            .find(".btn-download-chart")
            .off("click")
            .on("click", function () {
                downloadChartPDF(chart, data, chartInstance, $(this));
            });
    }

    function syncEntityTypesFromFilter() {
        state.filters.entityTypes = (state.filters.fieldFilters["__et__"] || []).map(String);
    }

    function refreshActiveTab() {
        syncEntityTypesFromFilter();
        saveFiltersCookie();
        var tab = state.tabs.find(function (t) {
            return parseInt(t.id, 10) === state.activeTab;
        });
        if (!tab) return;
        state.renderGen++;
        var myGen = state.renderGen;
        (tab.charts || []).forEach(function (chart) {
            fetchAndRenderChart(chart, myGen);
        });
        loadKPIData();
    }

    // ── Year dropdown ─────────────────────────────────────────────────────────

    function bindYearDropdown() {
        $(document).on("click", function (e) {
            if (!$(e.target).closest("#year-dropdown-wrapper").length) {
                closeYearDropdown();
            }
        });

        $("#year-dropdown-btn").on("click", function (e) {
            e.stopPropagation();
            var $panel = $("#year-dropdown-panel");
            if ($panel.hasClass("hidden")) {
                $panel.removeClass("hidden").css("display", "flex").addClass("flex-col");
                $("#year-dropdown-chevron").css("transform", "rotate(180deg)");
            } else {
                closeYearDropdown();
            }
        });
    }

    function closeYearDropdown() {
        $("#year-dropdown-panel").addClass("hidden").css("display", "");
        $("#year-dropdown-chevron").css("transform", "");
    }

    function updateYearDropdownLabel() {
        var $label = $("#year-dropdown-label");
        if (state.filters.years.length === 0) {
            $label.text(i18n.allYears || "Todos os anos");
        } else {
            $label.text(state.filters.years.slice().sort().join(", "));
        }
    }

    var pendingChartCount = 0;
    var applyLoadingActive = false;

    function markFiltersPending() {
        var $btn = $("#apply-filters-btn");
        $btn.prop("disabled", false).removeClass("opacity-30 cursor-not-allowed");
        updateClearBtn();
    }

    function clearFiltersPending() {
        var $btn = $("#apply-filters-btn");
        $btn.prop("disabled", true).addClass("opacity-30 cursor-not-allowed");
    }

    function updateClearBtn() {
        var defaultYear = cfg.publishedYear || cfg.currentYear;
        var yearsAreDefault =
            state.filters.years.length === (defaultYear ? 1 : 0) &&
            (!defaultYear || state.filters.years[0] === defaultYear);
        var fieldFiltersEmpty =
            Object.keys(state.filters.fieldFilters).filter(function (k) {
                return state.filters.fieldFilters[k] && state.filters.fieldFilters[k].length > 0;
            }).length === 0;
        var isDefault = yearsAreDefault && fieldFiltersEmpty;
        var $btn = $("#clear-filters-btn");
        $btn.prop("disabled", isDefault).toggleClass("opacity-30 cursor-not-allowed", isDefault);
    }

    function setApplyLoading(loading) {
        var $btn = $("#apply-filters-btn");
        if (loading) {
            applyLoadingActive = true;
            $btn.prop("disabled", true)
                .data("orig-text", $btn.text())
                .html(
                    '<svg class="animate-spin inline-block size-5 mr-2" fill="none" viewBox="0 0 24 24">' +
                        '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
                        '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>' +
                        "</svg>" +
                        ($btn.data("orig-text") || "")
                );
        } else {
            applyLoadingActive = false;
            $btn.prop("disabled", true)
                .addClass("opacity-30 cursor-not-allowed")
                .html($btn.data("orig-text") || $btn.text().replace(/^\s*/, ""));
        }
    }

    // ── Filters ───────────────────────────────────────────────────────────────

    function bindFilters() {
        $(document).on("click", ".year-pill", function () {
            var year = parseInt($(this).data("year"), 10);
            if (!year) return;

            // Seleção única: clicar num ano substitui a seleção (nunca acumula)
            if (state.filters.years.length === 1 && state.filters.years[0] === year) return;
            state.filters.years = [year];

            $(".year-pill").removeClass("active bg-primary text-white border-primary");
            $(this).addClass("active bg-primary text-white border-primary");

            updateYearDropdownLabel();
            closeYearDropdown();
            markFiltersPending();
        });

        // Show/hide options dropdown on hover (delay on close bridges the mt-2 gap)
        $(document).on("mouseenter", ".field-filter-pill-wrapper", function () {
            var $wrapper = $(this);
            clearTimeout($wrapper.data("_hoverTimer"));
            var $dropdown = $wrapper.find(".field-filter-dropdown");
            $(".field-filter-dropdown:not(.hidden)").not($dropdown[0]).addClass("hidden");
            $("#field-filter-add-dropdown").addClass("hidden");
            $dropdown.removeClass("hidden");
        });

        $(document).on("mouseleave", ".field-filter-pill-wrapper", function () {
            var $wrapper = $(this);
            var timer = setTimeout(function () {
                $wrapper.find(".field-filter-dropdown").addClass("hidden");
            }, 120);
            $wrapper.data("_hoverTimer", timer);
        });

        // Remove a field filter entirely
        $(document).on("click", ".field-filter-remove-btn", function (e) {
            e.stopPropagation();
            removeFieldFilter(String($(this).data("field-id")));
        });

        // Select all options for a field (or sub-field inside a group)
        $(document).on("change", ".field-filter-select-all", function () {
            var fid = String($(this).data("field-id"));
            var gid = $(this).data("group-id") ? String($(this).data("group-id")) : null;
            var checked = $(this).prop("checked");

            if (gid) {
                var group = availableFields.find(function (f) {
                    return String(f.id) === gid;
                });
                var sub =
                    group &&
                    group.sub_fields.find(function (s) {
                        return String(s.id) === fid;
                    });
                if (!sub) return;
                state.filters.fieldFilters[fid] = checked
                    ? sub.options.map(function (opt) {
                          return String(opt.value);
                      })
                    : [];
                var $wrapper = $(".field-filter-pill-wrapper[data-field-id='" + gid + "']");
                $wrapper.find(".field-filter-opt[data-field-id='" + fid + "']").prop("checked", checked);
                var total = 0;
                group.sub_fields.forEach(function (s) {
                    total += (state.filters.fieldFilters[String(s.id)] || []).length;
                });
                $wrapper.find(".field-filter-count").text(total);
            } else {
                var field = availableFields.find(function (f) {
                    return String(f.id) === fid;
                });
                if (!field) return;
                state.filters.fieldFilters[fid] = checked
                    ? field.options.map(function (opt) {
                          return String(opt.value);
                      })
                    : [];
                var $wrapper = $(".field-filter-pill-wrapper[data-field-id='" + fid + "']");
                $wrapper.find(".field-filter-opt").prop("checked", checked);
                $wrapper.find(".field-filter-count").text(state.filters.fieldFilters[fid].length);
            }
            markFiltersPending();
        });

        // Toggle individual option inside a field's checklist
        $(document).on("change", ".field-filter-opt", function () {
            var fid = String($(this).data("field-id"));
            var gid = $(this).data("group-id") ? String($(this).data("group-id")) : null;
            var value = String($(this).data("value"));
            var checked = $(this).prop("checked");

            if (!state.filters.fieldFilters[fid]) {
                state.filters.fieldFilters[fid] = [];
            }

            var idx = state.filters.fieldFilters[fid].indexOf(value);
            if (checked && idx === -1) {
                state.filters.fieldFilters[fid].push(value);
            } else if (!checked && idx > -1) {
                state.filters.fieldFilters[fid].splice(idx, 1);
            }

            var count = state.filters.fieldFilters[fid].length;

            if (gid) {
                var group = availableFields.find(function (f) {
                    return String(f.id) === gid;
                });
                var $wrapper = $(".field-filter-pill-wrapper[data-field-id='" + gid + "']");
                var total = 0;
                group &&
                    group.sub_fields.forEach(function (s) {
                        total += (state.filters.fieldFilters[String(s.id)] || []).length;
                    });
                $wrapper.find(".field-filter-count").text(total);
                var sub =
                    group &&
                    group.sub_fields.find(function (s) {
                        return String(s.id) === fid;
                    });
                if (sub) {
                    $wrapper
                        .find(".field-filter-select-all[data-field-id='" + fid + "']")
                        .prop("checked", count === sub.options.length && sub.options.length > 0);
                }
            } else {
                var $wrapper = $(".field-filter-pill-wrapper[data-field-id='" + fid + "']");
                $wrapper.find(".field-filter-count").text(count);
                var field = availableFields.find(function (f) {
                    return String(f.id) === fid;
                });
                if (field) {
                    $wrapper.find(".field-filter-select-all").prop("checked", count === field.options.length);
                }
            }
            markFiltersPending();
        });

        // Open/close add-field dropdown
        $(document).on("click", "#field-filter-add-btn", function (e) {
            e.stopPropagation();
            var $dropdown = $("#field-filter-add-dropdown");
            var wasOpen = !$dropdown.hasClass("hidden");

            closeAllFieldDropdowns();

            if (!wasOpen) {
                $dropdown.removeClass("hidden");
            }
        });

        // Add a field from the add-field dropdown
        $(document).on("click", ".field-filter-add-option", function (e) {
            e.stopPropagation();
            addFieldFilter(String($(this).data("field-id")));
            $("#field-filter-add-dropdown").addClass("hidden");
        });

        // Click outside: close dropdowns
        $(document).on("click.fieldFilter", function (e) {
            var $t = $(e.target);
            var insideOpts = $t.closest(".field-filter-pill-wrapper").length > 0;
            var insideAdd = $t.closest("#field-filter-add-wrapper").length > 0;

            if (!insideOpts) {
                closeAllFieldDropdowns();
            } else if (!insideAdd) {
                $("#field-filter-add-dropdown").addClass("hidden");
            }
        });

        // Apply filters button
        $(document).on("click", "#apply-filters-btn", function () {
            clearFiltersPending();
            setApplyLoading(true);
            refreshActiveTab();
        });

        // Clear filters button
        $(document).on("click", "#clear-filters-btn", function () {
            // Reset years to last available year
            var defaultYear = cfg.publishedYear || cfg.currentYear;
            state.filters.years = defaultYear ? [defaultYear] : [];
            $(".year-pill").removeClass("active bg-primary text-white border-primary");
            if (defaultYear) {
                $(".year-pill[data-year='" + defaultYear + "']").addClass("active bg-primary text-white");
            }
            updateYearDropdownLabel();

            // Reset field filters
            state.filters.fieldFilters = {};
            state.activeFieldIds = [];
            syncFieldFilterUI();

            clearFiltersPending();
            updateClearBtn();
            setApplyLoading(true);
            refreshActiveTab();
        });
    }

    function applyFilters(filters) {
        // Seleção única: coage cookies/default_search multi-ano ao ano mais recente
        var _yrs = (filters.years || []).map(Number).filter(Boolean);
        var _def = cfg.publishedYear || cfg.currentYear;
        state.filters.years = _yrs.length ? [Math.max.apply(null, _yrs)] : _def ? [_def] : [];

        $(".year-pill").each(function () {
            var y = parseInt($(this).data("year"), 10);
            var isActive = state.filters.years.indexOf(y) > -1;
            $(this).toggleClass("active bg-primary text-white", isActive);
        });

        // Backwards compat: old cookies store entity_types separately, not in field_filters.
        // Convert to __et__ entry so the virtual field pill renders correctly.
        var legacyEt = (filters.entity_types || []).map(String);
        if (legacyEt.length && (!filters.field_filters || !filters.field_filters["__et__"])) {
            filters.field_filters = filters.field_filters || {};
            filters.field_filters["__et__"] = legacyEt;
        }

        // Reset field filters
        state.filters.fieldFilters = {};
        state.activeFieldIds = [];

        if (filters.field_filters && Object.keys(filters.field_filters).length) {
            if (availableFields.length) {
                var applyGroupIds = [];
                Object.keys(filters.field_filters).forEach(function (fid) {
                    state.filters.fieldFilters[fid] = (filters.field_filters[fid] || []).map(String);
                    var group = availableFields.find(function (f) {
                        return (
                            f.is_group &&
                            f.sub_fields &&
                            f.sub_fields.some(function (s) {
                                return String(s.id) === fid;
                            })
                        );
                    });
                    if (group) {
                        var gid = String(group.id);
                        if (applyGroupIds.indexOf(gid) === -1) {
                            applyGroupIds.push(gid);
                            state.activeFieldIds.push(gid);
                        }
                    } else {
                        var field = availableFields.find(function (f) {
                            return String(f.id) === fid;
                        });
                        if (field) state.activeFieldIds.push(fid);
                    }
                });
                syncFieldFilterUI();
            } else {
                // Fields not loaded yet — renderFieldFilters() will apply after load
                state.pendingFieldFilters = filters.field_filters;
            }
        } else if (availableFields.length) {
            syncFieldFilterUI();
        }

        updateYearDropdownLabel();
        updateClearBtn();
        refreshActiveTab();
    }

    // ── PDF export ────────────────────────────────────────────────────────────

    function buildPdfFilterSummary() {
        var lines = [];

        if (state.filters.years.length) {
            lines.push(i18n.pdfYears + ": " + state.filters.years.slice().sort().join(", "));
        }

        Object.keys(state.filters.fieldFilters).forEach(function (fid) {
            var vals = state.filters.fieldFilters[fid];
            if (!vals || !vals.length) return;
            var fieldName = fid;
            var displayVals = vals;
            availableFields.forEach(function (f) {
                if (f.is_group && f.sub_fields) {
                    f.sub_fields.forEach(function (sf) {
                        if (String(sf.id) === fid) fieldName = sf.name;
                    });
                } else if (String(f.id) === fid) {
                    fieldName = f.name;
                    // Resolve option labels for display (e.g. entity type names)
                    displayVals = vals.map(function (v) {
                        var opt = (f.options || []).find(function (o) {
                            return String(o.value) === String(v);
                        });
                        return opt ? opt.label : v;
                    });
                }
            });
            lines.push(fieldName + ": " + displayVals.join(", "));
        });

        return lines;
    }

    function loadImageAsBase64(url, callback) {
        if (!url) {
            callback(null, 0, 0);
            return;
        }
        var img = new Image();
        img.onload = function () {
            var c = document.createElement("canvas");
            c.width = img.naturalWidth || img.width;
            c.height = img.naturalHeight || img.height;
            c.getContext("2d").drawImage(img, 0, 0);
            try {
                callback(c.toDataURL("image/jpeg"), c.width, c.height);
            } catch (e) {
                callback(null, 0, 0);
            }
        };
        img.onerror = function () {
            callback(null, 0, 0);
        };
        img.src = url;
    }

    function renderTextoA(doc, monthYear, methodFileUrl, x, y, maxW) {
        var fontSize = 7.5;
        var lineH = 4.5;
        var LINK_TEXT = i18n.textoALinkText || "neste link";
        var EMAIL_TEXT = i18n.textoAEmail || "healthbusiness@healthportugal.com";
        var template = i18n.textoABody || "";
        var parts = template.split("%s");
        var para =
            (parts[0] || "") +
            monthYear +
            (parts[1] || "") +
            LINK_TEXT +
            (parts[2] || "") +
            EMAIL_TEXT +
            (parts[3] || "");

        doc.setFontSize(fontSize);
        var lines = doc.splitTextToSize(para, maxW);
        var curY = y;

        lines.forEach(function (line) {
            var linkIdx = line.indexOf(LINK_TEXT);
            var emailIdx = line.indexOf(EMAIL_TEXT);

            if (linkIdx !== -1 && emailIdx !== -1) {
                // Both on same line: grey | link | grey | email
                var beforeLink = line.substring(0, linkIdx);
                var bLinkW = beforeLink ? doc.getTextWidth(beforeLink) : 0;
                var linkW = doc.getTextWidth(LINK_TEXT);
                var middle = line.substring(linkIdx + LINK_TEXT.length, emailIdx);
                var middleW = middle ? doc.getTextWidth(middle) : 0;
                var emailW = doc.getTextWidth(EMAIL_TEXT);
                var afterEmail = line.substring(emailIdx + EMAIL_TEXT.length);

                doc.setTextColor(100, 100, 100);
                if (beforeLink) doc.text(beforeLink, x, curY);

                if (methodFileUrl) {
                    doc.setTextColor(3, 45, 211);
                    doc.text(LINK_TEXT, x + bLinkW, curY);
                    doc.link(x + bLinkW, curY - lineH + 1, linkW, lineH, { url: methodFileUrl });
                } else {
                    doc.setTextColor(100, 100, 100);
                    doc.text(LINK_TEXT, x + bLinkW, curY);
                }

                doc.setTextColor(100, 100, 100);
                if (middle) doc.text(middle, x + bLinkW + linkW, curY);

                doc.setTextColor(3, 45, 211);
                doc.text(EMAIL_TEXT, x + bLinkW + linkW + middleW, curY);
                doc.link(x + bLinkW + linkW + middleW, curY - lineH + 1, emailW, lineH, {
                    url: "mailto:" + EMAIL_TEXT,
                });

                doc.setTextColor(100, 100, 100);
                if (afterEmail) doc.text(afterEmail, x + bLinkW + linkW + middleW + emailW, curY);
            } else if (linkIdx !== -1) {
                var before = line.substring(0, linkIdx);
                var bW = before ? doc.getTextWidth(before) : 0;
                var linkW = doc.getTextWidth(LINK_TEXT);
                var after = line.substring(linkIdx + LINK_TEXT.length);

                doc.setTextColor(100, 100, 100);
                if (before) doc.text(before, x, curY);
                if (methodFileUrl) {
                    doc.setTextColor(3, 45, 211);
                    doc.text(LINK_TEXT, x + bW, curY);
                    doc.link(x + bW, curY - lineH + 1, linkW, lineH, { url: methodFileUrl });
                } else {
                    doc.text(LINK_TEXT, x + bW, curY);
                }
                doc.setTextColor(100, 100, 100);
                if (after) doc.text(after, x + bW + linkW, curY);
            } else if (emailIdx !== -1) {
                var before = line.substring(0, emailIdx);
                var bW = before ? doc.getTextWidth(before) : 0;
                var emailW = doc.getTextWidth(EMAIL_TEXT);

                doc.setTextColor(100, 100, 100);
                if (before) doc.text(before, x, curY);
                doc.setTextColor(3, 45, 211);
                doc.text(EMAIL_TEXT, x + bW, curY);
                doc.link(x + bW, curY - lineH + 1, emailW, lineH, { url: "mailto:" + EMAIL_TEXT });
            } else {
                doc.setTextColor(100, 100, 100);
                doc.text(line, x, curY);
            }
            curY += lineH;
        });

        doc.setTextColor(0, 0, 0);
        return curY;
    }

    function buildPdfTable(doc, data, marginL, startY, contentW, pageH) {
        var isPrivate = data.x_field_private || data.y_field_private;
        var datasets = (data.datasets || []).filter(function (ds) {
            return ds.label !== "_trend" && ds.label !== "_avg";
        });
        var labels = data.labels || [];
        var groups = data.groups || [];
        if (!labels.length || !datasets.length) return;

        // When groups exist (grouped/stacked charts), build a richer display label per index.
        // groups[i].start + k maps to the real row; group label is the "category" (e.g. area name)
        // and labels[index] is the sub-label (e.g. year). Show "Category (Year)" when count > 1,
        // or just "Category" when each group has a single sub-row.
        var displayLabels = labels.map(function (l) {
            return String(l || "");
        });
        if (groups.length) {
            groups.forEach(function (g) {
                for (var k = 0; k < g.count; k++) {
                    var idx = g.start + k;
                    if (idx >= labels.length) return;
                    var sub = String(labels[idx] || "");
                    displayLabels[idx] = g.count === 1 ? g.label : g.label + " (" + sub + ")";
                }
            });
        }

        var rowH = 6.5;
        var labelColW = datasets.length > 1 ? contentW * 0.35 : contentW * 0.5;
        var dataColW = (contentW - labelColW) / Math.max(datasets.length, 1);
        var curY = startY;

        function truncate(text, maxW) {
            var s = String(text || "");
            if (doc.getTextWidth(s) <= maxW) return s;
            while (s.length > 0 && doc.getTextWidth(s + "…") > maxW) {
                s = s.slice(0, -1);
            }
            return s + "…";
        }

        // Header row
        doc.setFillColor(220, 220, 220);
        doc.rect(marginL, curY, contentW, rowH, "F");
        doc.setFontSize(8);
        doc.setFont(undefined, "bold");
        doc.text("—", marginL + 2, curY + rowH - 1.5);
        datasets.forEach(function (ds, j) {
            var x = marginL + labelColW + j * dataColW;
            doc.text(truncate(ds.label || "", dataColW - 4), x + 2, curY + rowH - 1.5);
        });
        doc.setFont(undefined, "normal");
        curY += rowH;

        var visibleIdx = 0;
        labels.forEach(function (label, i) {
            if (label === "" || label === null || label === undefined) return;

            if (curY + rowH > pageH - 10) {
                doc.addPage();
                curY = 15;
            }

            if (visibleIdx % 2 === 1) {
                doc.setFillColor(245, 245, 245);
                doc.rect(marginL, curY, contentW, rowH, "F");
            }
            visibleIdx++;

            doc.setFontSize(8);
            if (isPrivate) {
                doc.setTextColor(180, 180, 180);
                doc.text("****", marginL + 2, curY + rowH - 1.5);
                datasets.forEach(function (ds, j) {
                    doc.text("****", marginL + labelColW + j * dataColW + 2, curY + rowH - 1.5);
                });
                doc.setTextColor(0, 0, 0);
            } else {
                doc.text(truncate(displayLabels[i], labelColW - 4), marginL + 2, curY + rowH - 1.5);
                datasets.forEach(function (ds, j) {
                    var val = ds.data[i];
                    var valStr = val === null || val === undefined ? "" : formatNumber(val);
                    doc.text(valStr, marginL + labelColW + j * dataColW + 2, curY + rowH - 1.5);
                });
            }
            curY += rowH;
        });

        return curY;
    }

    function scaleFontSizes(obj, scale) {
        if (!obj || typeof obj !== "object") return;
        Object.keys(obj).forEach(function (k) {
            var v = obj[k];
            if (k === "font" && v && typeof v === "object" && typeof v.size === "number") {
                v.size = v.size * scale;
            } else if (v && typeof v === "object") {
                scaleFontSizes(v, scale);
            }
        });
    }

    function renderHiResChartCanvas(chartInstance, targetW) {
        var src = chartInstance.canvas;
        // Chart.js logical (CSS) size — independent of devicePixelRatio
        var srcLogicalW = chartInstance.width || src.width;
        var srcLogicalH = chartInstance.height || src.height;
        var W = targetW;
        var H = Math.round((W * srcLogicalH) / srcLogicalW);
        var scale = W / srcLogicalW;
        var off = document.createElement("canvas");
        off.width = W;
        off.height = H;
        var ctx = off.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);

        var cfg = chartInstance.config;
        var clonedOptions = $.extend(true, {}, cfg.options || {}, {
            responsive: false,
            maintainAspectRatio: false,
            animation: { duration: 0 },
            devicePixelRatio: 1,
            plugins: { tooltip: { enabled: false } },
        });
        scaleFontSizes(clonedOptions, scale);

        // Force legend color box + padding to scale with the chart
        clonedOptions.plugins = clonedOptions.plugins || {};
        clonedOptions.plugins.legend = clonedOptions.plugins.legend || {};
        clonedOptions.plugins.legend.labels = clonedOptions.plugins.legend.labels || {};
        var lbl = clonedOptions.plugins.legend.labels;
        var origBoxW = typeof lbl.boxWidth === "number" ? lbl.boxWidth : 40;
        var origBoxH = typeof lbl.boxHeight === "number" ? lbl.boxHeight : Chart.defaults.font.size;
        var origPad = typeof lbl.padding === "number" ? lbl.padding : 10;
        lbl.boxWidth = origBoxW * scale;
        lbl.boxHeight = origBoxH * scale;
        lbl.padding = origPad * scale;

        var origDefaultSize = Chart.defaults.font.size;
        Chart.defaults.font.size = origDefaultSize * scale;

        var whiteBgPlugin = {
            id: "whiteBgExport",
            beforeDraw: function (ch) {
                var c = ch.ctx;
                c.save();
                c.globalCompositeOperation = "destination-over";
                c.fillStyle = "#ffffff";
                c.fillRect(0, 0, ch.width, ch.height);
                c.restore();
            },
        };

        var tempChart;
        var dataUrl;
        try {
            tempChart = new Chart(ctx, {
                type: cfg.type,
                data: cfg.data,
                options: clonedOptions,
                plugins: (cfg.plugins || []).concat([whiteBgPlugin]),
            });
            dataUrl = off.toDataURL("image/jpeg", 0.85);
        } finally {
            Chart.defaults.font.size = origDefaultSize;
            if (tempChart) tempChart.destroy();
        }
        return { dataUrl: dataUrl, width: W, height: H, format: "JPEG" };
    }

    function buildPdfChartCanvas(chart, data) {
        var W = 1400;

        if (state.chartObjs[chart.id]) {
            return renderHiResChartCanvas(state.chartObjs[chart.id], 1800);
        }

        var ct = chart.chart_type || "bar";
        var isHorizontal = ct.indexOf("horizontal") > -1;
        var isLine = ct === "line" || ct === "area" || ct === "line_multi";
        var isPie = ct === "pie" || ct === "doughnut";
        var isStacked = ct.indexOf("stacked") > -1;
        var H = Math.round(W * (isPie ? 0.7 : 0.45));
        var off = document.createElement("canvas");
        off.width = W;
        off.height = H;
        var ctx = off.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);

        var type = isPie ? ct : isLine ? "line" : "bar";
        var datasets = (data.datasets || [])
            .filter(function (ds) {
                return ds.label !== "_trend" && ds.label !== "_avg";
            })
            .map(function (ds, i) {
                return Object.assign({}, ds, {
                    backgroundColor: ds.backgroundColor || hexToRgba(PALETTE[i % PALETTE.length], 0.85),
                    fill: ct === "area",
                });
            });
        var labels = (data.labels || []).map(function (l) {
            return l === "" ? " " : String(l || "");
        });

        var whiteBgPluginFallback = {
            id: "whiteBgExportFallback",
            beforeDraw: function (ch) {
                var c = ch.ctx;
                c.save();
                c.globalCompositeOperation = "destination-over";
                c.fillStyle = "#ffffff";
                c.fillRect(0, 0, ch.width, ch.height);
                c.restore();
            },
        };
        var tempChart = new Chart(ctx, {
            type: type,
            data: { labels: labels, datasets: datasets },
            plugins: [whiteBgPluginFallback],
            options: {
                animation: { duration: 0 },
                responsive: false,
                devicePixelRatio: 1,
                indexAxis: isHorizontal ? "y" : "x",
                plugins: {
                    legend: {
                        display: datasets.length > 1,
                        position: "top",
                        labels: { color: "#333333", font: { size: 14 } },
                    },
                    tooltip: { enabled: false },
                },
                scales: isPie
                    ? {}
                    : {
                          x: {
                              stacked: isStacked,
                              grid: { color: "#eeeeee" },
                              ticks: { color: "#555555", maxRotation: 45 },
                          },
                          y: {
                              stacked: isStacked,
                              beginAtZero: true,
                              grid: { color: "#eeeeee" },
                              ticks: { color: "#555555" },
                          },
                      },
            },
        });
        var fallbackUrl = off.toDataURL("image/jpeg", 0.85);
        tempChart.destroy();
        return { dataUrl: fallbackUrl, width: W, height: H, format: "JPEG" };
    }

    function downloadChartPDF(chart, data, chartInstance, $btn) {
        if ($btn) $btn.prop("disabled", true).addClass("opacity-50");

        loadImageAsBase64(cfg.logoUrl || "", function (logoData, logoNatW, logoNatH) {
            var hi = renderHiResChartCanvas(chartInstance, 1600);
            var imgData = hi.dataUrl;
            var imgRatio = hi.height / hi.width;

            var doc = new window.jspdf.jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            var pageW = doc.internal.pageSize.getWidth();
            var pageH = doc.internal.pageSize.getHeight();
            var marginL = 15;
            var contentW = pageW - marginL * 2;

            // ── HEADER ROW: logo left, date right (table-like alignment) ───
            var headerTop = 5;
            var logoMaxH = 32;
            var headerRowH = logoMaxH;
            var headerMidY = headerTop + headerRowH / 2;

            if (logoData && logoNatW > 0 && logoNatH > 0) {
                var logoDisplayW = logoMaxH * (logoNatW / logoNatH);
                doc.addImage(logoData, "JPEG", marginL, headerTop, logoDisplayW, logoMaxH);
            }

            var dateStr = new Date().toLocaleDateString("pt-PT");
            doc.setFontSize(8);
            doc.setTextColor(130, 130, 130);
            doc.text(i18n.pdfDate + ": " + dateStr, pageW - marginL, headerMidY, { align: "right", baseline: "middle" });

            var curY = headerTop + headerRowH;
            doc.setDrawColor(210, 210, 210);
            doc.setLineWidth(0.3);
            doc.line(marginL, curY, pageW - marginL, curY);
            curY += 14;

            // ── TITLE ─────────────────────────────────────────────────────
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(18);
            doc.setFont(undefined, "bold");
            var titleLines = doc.splitTextToSize(chart.title || "", contentW);
            doc.text(titleLines, marginL, curY);
            doc.setFont(undefined, "normal");
            curY += titleLines.length * 8 + 3;

            // ── DESCRIPTION ───────────────────────────────────────────────
            if (chart.description) {
                doc.setFontSize(9);
                doc.setTextColor(90, 90, 90);
                var descLines = doc.splitTextToSize(chart.description, contentW);
                doc.text(descLines, marginL, curY);
                doc.setTextColor(0, 0, 0);
                curY += descLines.length * 5 + 3;
            }

            // ── CHART (2/3 width) ─────────────────────────────────────────
            var chartW = contentW * (2 / 3);
            var imgH = Math.round(imgRatio * chartW);
            var availH = pageH - curY - 40;
            if (imgH > availH) imgH = availH;
            doc.addImage(imgData, "JPEG", marginL, curY + 2, chartW, imgH);
            curY += imgH + 8;

            // ── ABOUT ─────────────────────────────────────────────────────
            if (chart.about) {
                doc.setFontSize(8);
                doc.setFont(undefined, "bold");
                doc.setTextColor(60, 60, 60);
                doc.text(i18n.pdfAbout || "Sobre este gráfico", marginL, curY);
                doc.setFont(undefined, "normal");
                curY += 4.5;
                var aboutLines = doc.splitTextToSize(chart.about, contentW);
                doc.setTextColor(90, 90, 90);
                doc.text(aboutLines, marginL, curY);
                doc.setTextColor(0, 0, 0);
                curY += aboutLines.length * 4.5 + 3;
            }

            // ── LEGEND ────────────────────────────────────────────────────
            if (chart.legend_json) {
                doc.setFontSize(7.5);
                doc.setTextColor(110, 110, 110);
                var legLines = doc.splitTextToSize(chart.legend_json, contentW);
                doc.text(legLines, marginL, curY);
                doc.setTextColor(0, 0, 0);
                curY += legLines.length * 4.5 + 5;
            }

            // ── DATA TABLE (same page if room, else new page) ─────────────
            var tableHeaderH = 10;
            var spaceNeeded = tableHeaderH + 3 * 6.5;
            if (curY + spaceNeeded > pageH - 10) {
                doc.addPage();
                curY = 15;
            } else {
                curY += 5;
            }

            var tableW = contentW * 0.75;
            doc.setFontSize(11);
            doc.setFont(undefined, "bold");
            doc.setTextColor(0, 0, 0);
            doc.text(i18n.pdfDataTable, marginL, curY);
            doc.setFont(undefined, "normal");
            curY += tableHeaderH;

            curY = buildPdfTable(doc, data, marginL, curY, tableW, pageH) || curY;

            // ── FILTROS ───────────────────────────────────────────────────
            curY += 16;
            if (curY + 12 > pageH - 10) {
                doc.addPage();
                curY = 15;
            }
            var filterLines = buildPdfFilterSummary();
            doc.setFontSize(8);
            if (filterLines.length) {
                doc.setTextColor(60, 60, 60);
                doc.setFont(undefined, "bold");
                doc.text(i18n.pdfFilters + ":", marginL, curY);
                doc.setFont(undefined, "normal");
                curY += 4.5;
                filterLines.forEach(function (fl) {
                    if (curY + 4.5 > pageH - 10) {
                        doc.addPage();
                        curY = 15;
                    }
                    doc.text(fl, marginL + 4, curY);
                    curY += 4.5;
                });
                doc.setTextColor(0, 0, 0);
            } else {
                doc.setTextColor(150, 150, 150);
                doc.text(i18n.pdfNoFilters, marginL, curY);
                doc.setTextColor(0, 0, 0);
                curY += 4.5;
            }

            // ── TEXTO A (after filters) ───────────────────────────────────
            curY += 5;
            if (curY + 20 > pageH - 10) {
                doc.addPage();
                curY = 15;
            }
            var ptMonths = [
                "janeiro",
                "fevereiro",
                "março",
                "abril",
                "maio",
                "junho",
                "julho",
                "agosto",
                "setembro",
                "outubro",
                "novembro",
                "dezembro",
            ];
            var now = new Date();
            var monthYear = ptMonths[now.getMonth()] + "/" + now.getFullYear();
            renderTextoA(doc, monthYear, cfg.methodFileUrl || "", marginL, curY, contentW);

            var filename = (chart.title || "chart").replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".pdf";
            doc.save(filename);
            if ($btn) $btn.prop("disabled", false).removeClass("opacity-50");
        });
    }

    function downloadAllChartsPDF($btn, tab) {
        if (!$btn.data("origHtml")) $btn.data("origHtml", $btn.html());
        var spinner =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="size-6 shrink-0" style="animation:spin 1s linear infinite">' +
            '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" opacity=".25"/>' +
            '<path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
            "</svg>";
        $btn
            .prop("disabled", true)
            .css("opacity", "0.7")
            .removeClass("opacity-50")
            .html(spinner + " A gerar...");

        var tabCharts = (tab && tab.charts ? tab.charts : []).filter(function (chart) {
            return parseInt(chart.is_disabled, 10) !== 1;
        });
        var allCharts = tabCharts.map(function (chart) {
            return { chart: chart, tabId: tab.id, tabTitle: tab.title };
        });

        if (!allCharts.length) {
            $btn.prop("disabled", false).css("opacity", "").html($btn.data("origHtml"));
            return;
        }

        var pending = allCharts.length;
        var results = new Array(allCharts.length);

        allCharts.forEach(function (item, idx) {
            post(
                "hcp_ind_get_chart_data",
                {
                    chart_id: item.chart.id,
                    years: state.filters.years,
                    entity_types: state.filters.entityTypes,
                    field_filters_json: JSON.stringify(state.filters.fieldFilters),
                },
                function (data) {
                    results[idx] = { chart: item.chart, data: data, tabId: item.tabId, tabTitle: item.tabTitle };
                    pending--;
                    if (pending === 0) buildGlobalPDF(results, $btn, tab);
                }
            );
        });
    }

    function buildGlobalPDF(results, $btn, tab) {
        loadImageAsBase64(cfg.logoUrl || "", function (logoData, logoNatW, logoNatH) {
            var doc = new window.jspdf.jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            var pageW = doc.internal.pageSize.getWidth();
            var pageH = doc.internal.pageSize.getHeight();
            var marginL = 15;
            var contentW = pageW - marginL * 2;
            var dateStr = new Date().toLocaleDateString("pt-PT");
            var tabTitle = tab && tab.title ? String(tab.title) : "";

            function renderPdfHeader() {
                var headerTop = 5;
                var logoMaxH = 32;
                var headerRowH = logoMaxH;
                var headerMidY = headerTop + headerRowH / 2;
                if (logoData && logoNatW > 0 && logoNatH > 0) {
                    var logoDisplayW = logoMaxH * (logoNatW / logoNatH);
                    doc.addImage(logoData, "JPEG", marginL, headerTop, logoDisplayW, logoMaxH);
                }
                doc.setFontSize(8);
                doc.setTextColor(130, 130, 130);
                doc.text(i18n.pdfDate + ": " + dateStr, pageW - marginL, headerMidY, { align: "right", baseline: "middle" });
                var sepY = headerTop + headerRowH;
                doc.setDrawColor(210, 210, 210);
                doc.setLineWidth(0.3);
                doc.line(marginL, sepY, pageW - marginL, sepY);
                return sepY + 14;
            }

            // ── FIRST PAGE: header + filters + texto A ────────────────────
            var introY = renderPdfHeader();
            var filterLines = buildPdfFilterSummary();
            doc.setFontSize(8);
            if (filterLines.length) {
                doc.setTextColor(60, 60, 60);
                doc.setFont(undefined, "bold");
                doc.text(i18n.pdfFilters + ":", marginL, introY);
                doc.setFont(undefined, "normal");
                introY += 4.5;
                filterLines.forEach(function (fl) {
                    if (introY + 4.5 > pageH - 10) { doc.addPage(); introY = 15; }
                    doc.text(fl, marginL + 4, introY);
                    introY += 4.5;
                });
                doc.setTextColor(0, 0, 0);
            } else {
                doc.setTextColor(150, 150, 150);
                doc.text(i18n.pdfNoFilters, marginL, introY);
                doc.setTextColor(0, 0, 0);
                introY += 4.5;
            }

            introY += 5;
            if (introY + 20 > pageH - 10) { doc.addPage(); introY = 15; }
            var introMonths = ["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"];
            var introNow = new Date();
            var introMonthYear = introMonths[introNow.getMonth()] + "/" + introNow.getFullYear();
            renderTextoA(doc, introMonthYear, cfg.methodFileUrl || "", marginL, introY, contentW);

            // ── CHARTS: one per page ─────────────────────────────────────
            results.forEach(function (item) {
                doc.addPage();
                var chart = item.chart;
                var data = item.data;
                var curY = renderPdfHeader();

                // TITLE
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(18);
                doc.setFont(undefined, "bold");
                var titleLines = doc.splitTextToSize(chart.title || "", contentW);
                doc.text(titleLines, marginL, curY);
                doc.setFont(undefined, "normal");
                curY += titleLines.length * 8 + 3;

                // DESCRIPTION
                if (chart.description) {
                    doc.setFontSize(9);
                    doc.setTextColor(90, 90, 90);
                    var descLines = doc.splitTextToSize(chart.description, contentW);
                    doc.text(descLines, marginL, curY);
                    doc.setTextColor(0, 0, 0);
                    curY += descLines.length * 5 + 3;
                }

                // CHART (2/3 width, hi-res via buildPdfChartCanvas)
                var pdfCanvas = buildPdfChartCanvas(chart, data);
                var imgRatio = pdfCanvas.height / pdfCanvas.width;
                var chartW = contentW * (2 / 3);
                var imgH = Math.round(imgRatio * chartW);
                var availH = pageH - curY - 40;
                if (imgH > availH) imgH = availH;
                doc.addImage(pdfCanvas.dataUrl, pdfCanvas.format || "JPEG", marginL, curY + 2, chartW, imgH);
                curY += imgH + 8;

                // ABOUT
                if (chart.about) {
                    doc.setFontSize(8);
                    doc.setFont(undefined, "bold");
                    doc.setTextColor(60, 60, 60);
                    doc.text(i18n.pdfAbout || "Sobre este gráfico", marginL, curY);
                    doc.setFont(undefined, "normal");
                    curY += 4.5;
                    var aboutLines = doc.splitTextToSize(chart.about, contentW);
                    doc.setTextColor(90, 90, 90);
                    doc.text(aboutLines, marginL, curY);
                    doc.setTextColor(0, 0, 0);
                    curY += aboutLines.length * 4.5 + 3;
                }

                // LEGEND
                if (chart.legend_json) {
                    doc.setFontSize(7.5);
                    doc.setTextColor(110, 110, 110);
                    var legLines = doc.splitTextToSize(chart.legend_json, contentW);
                    doc.text(legLines, marginL, curY);
                    doc.setTextColor(0, 0, 0);
                    curY += legLines.length * 4.5 + 5;
                }

                // TABLE
                var tableHeaderH = 10;
                var spaceNeeded = tableHeaderH + 3 * 6.5;
                if (curY + spaceNeeded > pageH - 10) {
                    doc.addPage();
                    curY = 15;
                } else {
                    curY += 5;
                }
                var tableW = contentW * 0.75;
                doc.setFontSize(11);
                doc.setFont(undefined, "bold");
                doc.setTextColor(0, 0, 0);
                doc.text(i18n.pdfDataTable, marginL, curY);
                doc.setFont(undefined, "normal");
                curY += tableHeaderH;
                curY = buildPdfTable(doc, data, marginL, curY, tableW, pageH) || curY;
            });

            var dateFile = new Date().toISOString().slice(0, 10);
            var slugTitle =
                tabTitle
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/^-|-$/g, "") || "indicadores";
            doc.save(slugTitle + "-" + dateFile + ".pdf");

            $btn.prop("disabled", false).css("opacity", "");
            if ($btn.data("origHtml")) $btn.html($btn.data("origHtml"));
        });
    }

    // ── Utilities ─────────────────────────────────────────────────────────────

    function wrapTip(text, maxChars) {
        if (!text || text.length <= maxChars) return text;
        var words = String(text).split(" ");
        var lines = [];
        var current = "";
        words.forEach(function (w) {
            var candidate = current ? current + " " + w : w;
            if (candidate.length > maxChars) {
                if (current) lines.push(current);
                current = w;
            } else {
                current = candidate;
            }
        });
        if (current) lines.push(current);
        return lines;
    }

    function escHtml(str) {
        return String(str || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function formatNumber(n) {
        n = parseFloat(n) || 0;
        return n.toLocaleString("pt-PT", { maximumFractionDigits: 2 });
    }

    // Devolve "X%" — valor n como percentagem do total de `dataArr`.
    function formatPercent(n, dataArr) {
        n = parseFloat(n) || 0;
        var total = (dataArr || []).reduce(function (s, v) {
            return s + (typeof v === "number" ? v : parseFloat(v) || 0);
        }, 0);
        var pct = total > 0 ? (n / total) * 100 : 0;
        return pct.toLocaleString("pt-PT", { maximumFractionDigits: 1 }) + "%";
    }
})(jQuery);
